/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as WizardRouteImport } from './routes/wizard'
import { Route as SelfRegisterRouteImport } from './routes/self-register'
import { Route as SelectRoleRouteImport } from './routes/select-role'
import { Route as NoAccessRouteImport } from './routes/no-access'
import { Route as LoginRouteImport } from './routes/login'
import { Route as ForgotPasswordRouteImport } from './routes/forgot-password'
import { Route as ActivateRouteImport } from './routes/activate'
import { Route as BackofficeRouteImport } from './routes/_backoffice'
import { Route as WizardIndexRouteImport } from './routes/wizard.index'
import { Route as LoginIndexRouteImport } from './routes/login.index'
import { Route as DocsIndexRouteImport } from './routes/docs.index'
import { Route as LoginNewPasswordRouteImport } from './routes/login.new-password'
import { Route as LoginMfaTotpSetupRouteImport } from './routes/login.mfa-totp-setup'
import { Route as LoginMfaSetupRouteImport } from './routes/login.mfa-setup'
import { Route as LoginMfaEmailSetupRouteImport } from './routes/login.mfa-email-setup'
import { Route as LoginMfaChallengeRouteImport } from './routes/login.mfa-challenge'
import { Route as DevWizardPlaygroundRouteImport } from './routes/dev.wizard-playground'
import { Route as BackofficeSuperadminRouteImport } from './routes/_backoffice.superadmin'
import { Route as BackofficeSalesRouteImport } from './routes/_backoffice.sales'
import { Route as BackofficeRetailAdminRouteImport } from './routes/_backoffice.retail-admin'
import { Route as BackofficeCreditRouteImport } from './routes/_backoffice.credit'
import { Route as BackofficeCollectionsRouteImport } from './routes/_backoffice.collections'
import { Route as AuthenticatedLayoutRouteImport } from './routes/_authenticated/_layout'
import { Route as DocsDocIdIndexRouteImport } from './routes/docs.$docId.index'
import { Route as BackofficeSuperadminIndexRouteImport } from './routes/_backoffice.superadmin.index'
import { Route as BackofficeSalesIndexRouteImport } from './routes/_backoffice.sales.index'
import { Route as BackofficeRetailAdminIndexRouteImport } from './routes/_backoffice.retail-admin.index'
import { Route as BackofficeCreditIndexRouteImport } from './routes/_backoffice.credit.index'
import { Route as BackofficeCollectionsIndexRouteImport } from './routes/_backoffice.collections.index'
import { Route as AuthenticatedLayoutIndexRouteImport } from './routes/_authenticated/_layout.index'
import { Route as WizardSSessionIdRouteImport } from './routes/wizard.s.$sessionId'
import { Route as DocsDocIdSectionIdRouteImport } from './routes/docs.$docId.$sectionId'
import { Route as BackofficeSuperadminGlobalConfigRouteImport } from './routes/_backoffice.superadmin.global-config'
import { Route as BackofficeSuperadminSectionRouteImport } from './routes/_backoffice.superadmin.$section'
import { Route as BackofficeSalesSectionRouteImport } from './routes/_backoffice.sales.$section'
import { Route as BackofficeRetailAdminSectionRouteImport } from './routes/_backoffice.retail-admin.$section'
import { Route as BackofficeCreditTransfersRouteImport } from './routes/_backoffice.credit.transfers'
import { Route as BackofficeCreditSegmentsRouteImport } from './routes/_backoffice.credit.segments'
import { Route as BackofficeCreditReportsRouteImport } from './routes/_backoffice.credit.reports'
import { Route as BackofficeCreditReconciliationRouteImport } from './routes/_backoffice.credit.reconciliation'
import { Route as BackofficeCreditPromotionsRouteImport } from './routes/_backoffice.credit.promotions'
import { Route as BackofficeCreditPortfolioRouteImport } from './routes/_backoffice.credit.portfolio'
import { Route as BackofficeCreditPoliciesRouteImport } from './routes/_backoffice.credit.policies'
import { Route as BackofficeCreditOriginationRouteImport } from './routes/_backoffice.credit.origination'
import { Route as BackofficeCreditModeliaRouteImport } from './routes/_backoffice.credit.modelia'
import { Route as BackofficeCreditMdmRouteImport } from './routes/_backoffice.credit.mdm'
import { Route as BackofficeCreditInstallmentsRouteImport } from './routes/_backoffice.credit.installments'
import { Route as BackofficeCreditCustomersRouteImport } from './routes/_backoffice.credit.customers'
import { Route as BackofficeCreditCustomerMessagesRouteImport } from './routes/_backoffice.credit.customer-messages'
import { Route as BackofficeCreditCollectionsRouteImport } from './routes/_backoffice.credit.collections'
import { Route as BackofficeCreditCohortsRouteImport } from './routes/_backoffice.credit.cohorts'
import { Route as BackofficeCreditSectionRouteImport } from './routes/_backoffice.credit.$section'
import { Route as BackofficeCollectionsPromisesRouteImport } from './routes/_backoffice.collections.promises'
import { Route as BackofficeCollectionsPaymentsRouteImport } from './routes/_backoffice.collections.payments'
import { Route as BackofficeCollectionsCustomersRouteImport } from './routes/_backoffice.collections.customers'
import { Route as BackofficeCollectionsAgendaRouteImport } from './routes/_backoffice.collections.agenda'
import { Route as BackofficeCollectionsSectionRouteImport } from './routes/_backoffice.collections.$section'
import { Route as AuthenticatedLayoutPlatformRouteImport } from './routes/_authenticated/_layout.platform'
import { Route as WizardSSessionIdIndexRouteImport } from './routes/wizard.s.$sessionId.index'
import { Route as WizardSSessionIdStepRouteImport } from './routes/wizard.s.$sessionId.$step'
import { Route as AuthenticatedLayoutTenantSecurityRouteImport } from './routes/_authenticated/_layout.tenant.security'
import { Route as AuthenticatedLayoutTenantGroupsRouteImport } from './routes/_authenticated/_layout.tenant.groups'
import { Route as AuthenticatedLayoutTenantBrandingRouteImport } from './routes/_authenticated/_layout.tenant.branding'
import { Route as AuthenticatedLayoutTenantAuditRouteImport } from './routes/_authenticated/_layout.tenant.audit'
import { Route as AuthenticatedLayoutSeccionKeyRouteImport } from './routes/_authenticated/_layout.seccion.$key'
import { Route as AuthenticatedLayoutPlatformTenantTypesRouteImport } from './routes/_authenticated/_layout.platform.tenant-types'
import { Route as AuthenticatedLayoutPlatformSecurityRouteImport } from './routes/_authenticated/_layout.platform.security'
import { Route as AuthenticatedLayoutPlatformRolesRouteImport } from './routes/_authenticated/_layout.platform.roles'
import { Route as AuthenticatedLayoutPlatformBrandingRouteImport } from './routes/_authenticated/_layout.platform.branding'
import { Route as AuthenticatedLayoutPlatformAuditRouteImport } from './routes/_authenticated/_layout.platform.audit'
import { Route as AuthenticatedLayoutPlatformAdminsRouteImport } from './routes/_authenticated/_layout.platform.admins'
import { Route as AuthenticatedLayoutMeProfileRouteImport } from './routes/_authenticated/_layout.me.profile'
import { Route as AuthenticatedLayoutTenantUsersIndexRouteImport } from './routes/_authenticated/_layout.tenant.users.index'
import { Route as AuthenticatedLayoutTenantRolesIndexRouteImport } from './routes/_authenticated/_layout.tenant.roles.index'
import { Route as AuthenticatedLayoutPlatformTenantsIndexRouteImport } from './routes/_authenticated/_layout.platform.tenants.index'
import { Route as AuthenticatedLayoutPlatformApplicationsIndexRouteImport } from './routes/_authenticated/_layout.platform.applications.index'
import { Route as AuthenticatedLayoutMeSecurityIndexRouteImport } from './routes/_authenticated/_layout.me.security.index'
import { Route as AuthenticatedLayoutTenantUsersNewRouteImport } from './routes/_authenticated/_layout.tenant.users.new'
import { Route as AuthenticatedLayoutTenantRolesRoleIdRouteImport } from './routes/_authenticated/_layout.tenant.roles.$roleId'
import { Route as AuthenticatedLayoutPlatformTenantsTenantIdRouteImport } from './routes/_authenticated/_layout.platform.tenants.$tenantId'
import { Route as AuthenticatedLayoutPlatformApplicationsApplicationIdRouteImport } from './routes/_authenticated/_layout.platform.applications.$applicationId'
import { Route as AuthenticatedLayoutMeSecurityMfaTotpSetupRouteImport } from './routes/_authenticated/_layout.me.security.mfa-totp-setup'
import { Route as AuthenticatedLayoutMeSecurityMfaSmsSetupRouteImport } from './routes/_authenticated/_layout.me.security.mfa-sms-setup'
import { Route as AuthenticatedLayoutMeSecurityMfaSetupRouteImport } from './routes/_authenticated/_layout.me.security.mfa-setup'
import { Route as AuthenticatedLayoutMeSecurityMfaPreferenceRouteImport } from './routes/_authenticated/_layout.me.security.mfa-preference'
import { Route as AuthenticatedLayoutMeSecurityMfaEmailSetupRouteImport } from './routes/_authenticated/_layout.me.security.mfa-email-setup'
import { Route as AuthenticatedLayoutMeSecurityChangePasswordRouteImport } from './routes/_authenticated/_layout.me.security.change-password'
import { Route as AuthenticatedLayoutPlatformTenantsTenantIdIndexRouteImport } from './routes/_authenticated/_layout.platform.tenants.$tenantId.index'
import { Route as AuthenticatedLayoutPlatformTenantsTenantIdUsersRouteImport } from './routes/_authenticated/_layout.platform.tenants.$tenantId.users'
import { Route as AuthenticatedLayoutPlatformTenantsTenantIdUserFieldsRouteImport } from './routes/_authenticated/_layout.platform.tenants.$tenantId.user-fields'
import { Route as AuthenticatedLayoutPlatformTenantsTenantIdRolesRouteImport } from './routes/_authenticated/_layout.platform.tenants.$tenantId.roles'
import { Route as AuthenticatedLayoutPlatformTenantsTenantIdBrandingRouteImport } from './routes/_authenticated/_layout.platform.tenants.$tenantId.branding'
import { Route as AuthenticatedLayoutPlatformTenantsTenantIdLevelsLevelRouteImport } from './routes/_authenticated/_layout.platform.tenants.$tenantId.levels.$level'

const WizardRoute = WizardRouteImport.update({
  id: '/wizard',
  path: '/wizard',
  getParentRoute: () => rootRouteImport,
} as any)
const SelfRegisterRoute = SelfRegisterRouteImport.update({
  id: '/self-register',
  path: '/self-register',
  getParentRoute: () => rootRouteImport,
} as any)
const SelectRoleRoute = SelectRoleRouteImport.update({
  id: '/select-role',
  path: '/select-role',
  getParentRoute: () => rootRouteImport,
} as any)
const NoAccessRoute = NoAccessRouteImport.update({
  id: '/no-access',
  path: '/no-access',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const ForgotPasswordRoute = ForgotPasswordRouteImport.update({
  id: '/forgot-password',
  path: '/forgot-password',
  getParentRoute: () => rootRouteImport,
} as any)
const ActivateRoute = ActivateRouteImport.update({
  id: '/activate',
  path: '/activate',
  getParentRoute: () => rootRouteImport,
} as any)
const BackofficeRoute = BackofficeRouteImport.update({
  id: '/_backoffice',
  getParentRoute: () => rootRouteImport,
} as any)
const WizardIndexRoute = WizardIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => WizardRoute,
} as any)
const LoginIndexRoute = LoginIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => LoginRoute,
} as any)
const DocsIndexRoute = DocsIndexRouteImport.update({
  id: '/docs/',
  path: '/docs/',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginNewPasswordRoute = LoginNewPasswordRouteImport.update({
  id: '/new-password',
  path: '/new-password',
  getParentRoute: () => LoginRoute,
} as any)
const LoginMfaTotpSetupRoute = LoginMfaTotpSetupRouteImport.update({
  id: '/mfa-totp-setup',
  path: '/mfa-totp-setup',
  getParentRoute: () => LoginRoute,
} as any)
const LoginMfaSetupRoute = LoginMfaSetupRouteImport.update({
  id: '/mfa-setup',
  path: '/mfa-setup',
  getParentRoute: () => LoginRoute,
} as any)
const LoginMfaEmailSetupRoute = LoginMfaEmailSetupRouteImport.update({
  id: '/mfa-email-setup',
  path: '/mfa-email-setup',
  getParentRoute: () => LoginRoute,
} as any)
const LoginMfaChallengeRoute = LoginMfaChallengeRouteImport.update({
  id: '/mfa-challenge',
  path: '/mfa-challenge',
  getParentRoute: () => LoginRoute,
} as any)
const DevWizardPlaygroundRoute = DevWizardPlaygroundRouteImport.update({
  id: '/dev/wizard-playground',
  path: '/dev/wizard-playground',
  getParentRoute: () => rootRouteImport,
} as any)
const BackofficeSuperadminRoute = BackofficeSuperadminRouteImport.update({
  id: '/superadmin',
  path: '/superadmin',
  getParentRoute: () => BackofficeRoute,
} as any)
const BackofficeSalesRoute = BackofficeSalesRouteImport.update({
  id: '/sales',
  path: '/sales',
  getParentRoute: () => BackofficeRoute,
} as any)
const BackofficeRetailAdminRoute = BackofficeRetailAdminRouteImport.update({
  id: '/retail-admin',
  path: '/retail-admin',
  getParentRoute: () => BackofficeRoute,
} as any)
const BackofficeCreditRoute = BackofficeCreditRouteImport.update({
  id: '/credit',
  path: '/credit',
  getParentRoute: () => BackofficeRoute,
} as any)
const BackofficeCollectionsRoute = BackofficeCollectionsRouteImport.update({
  id: '/collections',
  path: '/collections',
  getParentRoute: () => BackofficeRoute,
} as any)
const AuthenticatedLayoutRoute = AuthenticatedLayoutRouteImport.update({
  id: '/_authenticated/_layout',
  getParentRoute: () => rootRouteImport,
} as any)
const DocsDocIdIndexRoute = DocsDocIdIndexRouteImport.update({
  id: '/docs/$docId/',
  path: '/docs/$docId/',
  getParentRoute: () => rootRouteImport,
} as any)
const BackofficeSuperadminIndexRoute =
  BackofficeSuperadminIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => BackofficeSuperadminRoute,
  } as any)
const BackofficeSalesIndexRoute = BackofficeSalesIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => BackofficeSalesRoute,
} as any)
const BackofficeRetailAdminIndexRoute =
  BackofficeRetailAdminIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => BackofficeRetailAdminRoute,
  } as any)
const BackofficeCreditIndexRoute = BackofficeCreditIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => BackofficeCreditRoute,
} as any)
const BackofficeCollectionsIndexRoute =
  BackofficeCollectionsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => BackofficeCollectionsRoute,
  } as any)
const AuthenticatedLayoutIndexRoute =
  AuthenticatedLayoutIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedLayoutRoute,
  } as any)
const WizardSSessionIdRoute = WizardSSessionIdRouteImport.update({
  id: '/s/$sessionId',
  path: '/s/$sessionId',
  getParentRoute: () => WizardRoute,
} as any)
const DocsDocIdSectionIdRoute = DocsDocIdSectionIdRouteImport.update({
  id: '/docs/$docId/$sectionId',
  path: '/docs/$docId/$sectionId',
  getParentRoute: () => rootRouteImport,
} as any)
const BackofficeSuperadminGlobalConfigRoute =
  BackofficeSuperadminGlobalConfigRouteImport.update({
    id: '/global-config',
    path: '/global-config',
    getParentRoute: () => BackofficeSuperadminRoute,
  } as any)
const BackofficeSuperadminSectionRoute =
  BackofficeSuperadminSectionRouteImport.update({
    id: '/$section',
    path: '/$section',
    getParentRoute: () => BackofficeSuperadminRoute,
  } as any)
const BackofficeSalesSectionRoute = BackofficeSalesSectionRouteImport.update({
  id: '/$section',
  path: '/$section',
  getParentRoute: () => BackofficeSalesRoute,
} as any)
const BackofficeRetailAdminSectionRoute =
  BackofficeRetailAdminSectionRouteImport.update({
    id: '/$section',
    path: '/$section',
    getParentRoute: () => BackofficeRetailAdminRoute,
  } as any)
const BackofficeCreditTransfersRoute =
  BackofficeCreditTransfersRouteImport.update({
    id: '/transfers',
    path: '/transfers',
    getParentRoute: () => BackofficeCreditRoute,
  } as any)
const BackofficeCreditSegmentsRoute =
  BackofficeCreditSegmentsRouteImport.update({
    id: '/segments',
    path: '/segments',
    getParentRoute: () => BackofficeCreditRoute,
  } as any)
const BackofficeCreditReportsRoute = BackofficeCreditReportsRouteImport.update({
  id: '/reports',
  path: '/reports',
  getParentRoute: () => BackofficeCreditRoute,
} as any)
const BackofficeCreditReconciliationRoute =
  BackofficeCreditReconciliationRouteImport.update({
    id: '/reconciliation',
    path: '/reconciliation',
    getParentRoute: () => BackofficeCreditRoute,
  } as any)
const BackofficeCreditPromotionsRoute =
  BackofficeCreditPromotionsRouteImport.update({
    id: '/promotions',
    path: '/promotions',
    getParentRoute: () => BackofficeCreditRoute,
  } as any)
const BackofficeCreditPortfolioRoute =
  BackofficeCreditPortfolioRouteImport.update({
    id: '/portfolio',
    path: '/portfolio',
    getParentRoute: () => BackofficeCreditRoute,
  } as any)
const BackofficeCreditPoliciesRoute =
  BackofficeCreditPoliciesRouteImport.update({
    id: '/policies',
    path: '/policies',
    getParentRoute: () => BackofficeCreditRoute,
  } as any)
const BackofficeCreditOriginationRoute =
  BackofficeCreditOriginationRouteImport.update({
    id: '/origination',
    path: '/origination',
    getParentRoute: () => BackofficeCreditRoute,
  } as any)
const BackofficeCreditModeliaRoute = BackofficeCreditModeliaRouteImport.update({
  id: '/modelia',
  path: '/modelia',
  getParentRoute: () => BackofficeCreditRoute,
} as any)
const BackofficeCreditMdmRoute = BackofficeCreditMdmRouteImport.update({
  id: '/mdm',
  path: '/mdm',
  getParentRoute: () => BackofficeCreditRoute,
} as any)
const BackofficeCreditInstallmentsRoute =
  BackofficeCreditInstallmentsRouteImport.update({
    id: '/installments',
    path: '/installments',
    getParentRoute: () => BackofficeCreditRoute,
  } as any)
const BackofficeCreditCustomersRoute =
  BackofficeCreditCustomersRouteImport.update({
    id: '/customers',
    path: '/customers',
    getParentRoute: () => BackofficeCreditRoute,
  } as any)
const BackofficeCreditCustomerMessagesRoute =
  BackofficeCreditCustomerMessagesRouteImport.update({
    id: '/customer-messages',
    path: '/customer-messages',
    getParentRoute: () => BackofficeCreditRoute,
  } as any)
const BackofficeCreditCollectionsRoute =
  BackofficeCreditCollectionsRouteImport.update({
    id: '/collections',
    path: '/collections',
    getParentRoute: () => BackofficeCreditRoute,
  } as any)
const BackofficeCreditCohortsRoute = BackofficeCreditCohortsRouteImport.update({
  id: '/cohorts',
  path: '/cohorts',
  getParentRoute: () => BackofficeCreditRoute,
} as any)
const BackofficeCreditSectionRoute = BackofficeCreditSectionRouteImport.update({
  id: '/$section',
  path: '/$section',
  getParentRoute: () => BackofficeCreditRoute,
} as any)
const BackofficeCollectionsPromisesRoute =
  BackofficeCollectionsPromisesRouteImport.update({
    id: '/promises',
    path: '/promises',
    getParentRoute: () => BackofficeCollectionsRoute,
  } as any)
const BackofficeCollectionsPaymentsRoute =
  BackofficeCollectionsPaymentsRouteImport.update({
    id: '/payments',
    path: '/payments',
    getParentRoute: () => BackofficeCollectionsRoute,
  } as any)
const BackofficeCollectionsCustomersRoute =
  BackofficeCollectionsCustomersRouteImport.update({
    id: '/customers',
    path: '/customers',
    getParentRoute: () => BackofficeCollectionsRoute,
  } as any)
const BackofficeCollectionsAgendaRoute =
  BackofficeCollectionsAgendaRouteImport.update({
    id: '/agenda',
    path: '/agenda',
    getParentRoute: () => BackofficeCollectionsRoute,
  } as any)
const BackofficeCollectionsSectionRoute =
  BackofficeCollectionsSectionRouteImport.update({
    id: '/$section',
    path: '/$section',
    getParentRoute: () => BackofficeCollectionsRoute,
  } as any)
const AuthenticatedLayoutPlatformRoute =
  AuthenticatedLayoutPlatformRouteImport.update({
    id: '/platform',
    path: '/platform',
    getParentRoute: () => AuthenticatedLayoutRoute,
  } as any)
const WizardSSessionIdIndexRoute = WizardSSessionIdIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => WizardSSessionIdRoute,
} as any)
const WizardSSessionIdStepRoute = WizardSSessionIdStepRouteImport.update({
  id: '/$step',
  path: '/$step',
  getParentRoute: () => WizardSSessionIdRoute,
} as any)
const AuthenticatedLayoutTenantSecurityRoute =
  AuthenticatedLayoutTenantSecurityRouteImport.update({
    id: '/tenant/security',
    path: '/tenant/security',
    getParentRoute: () => AuthenticatedLayoutRoute,
  } as any)
const AuthenticatedLayoutTenantGroupsRoute =
  AuthenticatedLayoutTenantGroupsRouteImport.update({
    id: '/tenant/groups',
    path: '/tenant/groups',
    getParentRoute: () => AuthenticatedLayoutRoute,
  } as any)
const AuthenticatedLayoutTenantBrandingRoute =
  AuthenticatedLayoutTenantBrandingRouteImport.update({
    id: '/tenant/branding',
    path: '/tenant/branding',
    getParentRoute: () => AuthenticatedLayoutRoute,
  } as any)
const AuthenticatedLayoutTenantAuditRoute =
  AuthenticatedLayoutTenantAuditRouteImport.update({
    id: '/tenant/audit',
    path: '/tenant/audit',
    getParentRoute: () => AuthenticatedLayoutRoute,
  } as any)
const AuthenticatedLayoutSeccionKeyRoute =
  AuthenticatedLayoutSeccionKeyRouteImport.update({
    id: '/seccion/$key',
    path: '/seccion/$key',
    getParentRoute: () => AuthenticatedLayoutRoute,
  } as any)
const AuthenticatedLayoutPlatformTenantTypesRoute =
  AuthenticatedLayoutPlatformTenantTypesRouteImport.update({
    id: '/tenant-types',
    path: '/tenant-types',
    getParentRoute: () => AuthenticatedLayoutPlatformRoute,
  } as any)
const AuthenticatedLayoutPlatformSecurityRoute =
  AuthenticatedLayoutPlatformSecurityRouteImport.update({
    id: '/security',
    path: '/security',
    getParentRoute: () => AuthenticatedLayoutPlatformRoute,
  } as any)
const AuthenticatedLayoutPlatformRolesRoute =
  AuthenticatedLayoutPlatformRolesRouteImport.update({
    id: '/roles',
    path: '/roles',
    getParentRoute: () => AuthenticatedLayoutPlatformRoute,
  } as any)
const AuthenticatedLayoutPlatformBrandingRoute =
  AuthenticatedLayoutPlatformBrandingRouteImport.update({
    id: '/branding',
    path: '/branding',
    getParentRoute: () => AuthenticatedLayoutPlatformRoute,
  } as any)
const AuthenticatedLayoutPlatformAuditRoute =
  AuthenticatedLayoutPlatformAuditRouteImport.update({
    id: '/audit',
    path: '/audit',
    getParentRoute: () => AuthenticatedLayoutPlatformRoute,
  } as any)
const AuthenticatedLayoutPlatformAdminsRoute =
  AuthenticatedLayoutPlatformAdminsRouteImport.update({
    id: '/admins',
    path: '/admins',
    getParentRoute: () => AuthenticatedLayoutPlatformRoute,
  } as any)
const AuthenticatedLayoutMeProfileRoute =
  AuthenticatedLayoutMeProfileRouteImport.update({
    id: '/me/profile',
    path: '/me/profile',
    getParentRoute: () => AuthenticatedLayoutRoute,
  } as any)
const AuthenticatedLayoutTenantUsersIndexRoute =
  AuthenticatedLayoutTenantUsersIndexRouteImport.update({
    id: '/tenant/users/',
    path: '/tenant/users/',
    getParentRoute: () => AuthenticatedLayoutRoute,
  } as any)
const AuthenticatedLayoutTenantRolesIndexRoute =
  AuthenticatedLayoutTenantRolesIndexRouteImport.update({
    id: '/tenant/roles/',
    path: '/tenant/roles/',
    getParentRoute: () => AuthenticatedLayoutRoute,
  } as any)
const AuthenticatedLayoutPlatformTenantsIndexRoute =
  AuthenticatedLayoutPlatformTenantsIndexRouteImport.update({
    id: '/tenants/',
    path: '/tenants/',
    getParentRoute: () => AuthenticatedLayoutPlatformRoute,
  } as any)
const AuthenticatedLayoutPlatformApplicationsIndexRoute =
  AuthenticatedLayoutPlatformApplicationsIndexRouteImport.update({
    id: '/applications/',
    path: '/applications/',
    getParentRoute: () => AuthenticatedLayoutPlatformRoute,
  } as any)
const AuthenticatedLayoutMeSecurityIndexRoute =
  AuthenticatedLayoutMeSecurityIndexRouteImport.update({
    id: '/me/security/',
    path: '/me/security/',
    getParentRoute: () => AuthenticatedLayoutRoute,
  } as any)
const AuthenticatedLayoutTenantUsersNewRoute =
  AuthenticatedLayoutTenantUsersNewRouteImport.update({
    id: '/tenant/users/new',
    path: '/tenant/users/new',
    getParentRoute: () => AuthenticatedLayoutRoute,
  } as any)
const AuthenticatedLayoutTenantRolesRoleIdRoute =
  AuthenticatedLayoutTenantRolesRoleIdRouteImport.update({
    id: '/tenant/roles/$roleId',
    path: '/tenant/roles/$roleId',
    getParentRoute: () => AuthenticatedLayoutRoute,
  } as any)
const AuthenticatedLayoutPlatformTenantsTenantIdRoute =
  AuthenticatedLayoutPlatformTenantsTenantIdRouteImport.update({
    id: '/tenants/$tenantId',
    path: '/tenants/$tenantId',
    getParentRoute: () => AuthenticatedLayoutPlatformRoute,
  } as any)
const AuthenticatedLayoutPlatformApplicationsApplicationIdRoute =
  AuthenticatedLayoutPlatformApplicationsApplicationIdRouteImport.update({
    id: '/applications/$applicationId',
    path: '/applications/$applicationId',
    getParentRoute: () => AuthenticatedLayoutPlatformRoute,
  } as any)
const AuthenticatedLayoutMeSecurityMfaTotpSetupRoute =
  AuthenticatedLayoutMeSecurityMfaTotpSetupRouteImport.update({
    id: '/me/security/mfa-totp-setup',
    path: '/me/security/mfa-totp-setup',
    getParentRoute: () => AuthenticatedLayoutRoute,
  } as any)
const AuthenticatedLayoutMeSecurityMfaSmsSetupRoute =
  AuthenticatedLayoutMeSecurityMfaSmsSetupRouteImport.update({
    id: '/me/security/mfa-sms-setup',
    path: '/me/security/mfa-sms-setup',
    getParentRoute: () => AuthenticatedLayoutRoute,
  } as any)
const AuthenticatedLayoutMeSecurityMfaSetupRoute =
  AuthenticatedLayoutMeSecurityMfaSetupRouteImport.update({
    id: '/me/security/mfa-setup',
    path: '/me/security/mfa-setup',
    getParentRoute: () => AuthenticatedLayoutRoute,
  } as any)
const AuthenticatedLayoutMeSecurityMfaPreferenceRoute =
  AuthenticatedLayoutMeSecurityMfaPreferenceRouteImport.update({
    id: '/me/security/mfa-preference',
    path: '/me/security/mfa-preference',
    getParentRoute: () => AuthenticatedLayoutRoute,
  } as any)
const AuthenticatedLayoutMeSecurityMfaEmailSetupRoute =
  AuthenticatedLayoutMeSecurityMfaEmailSetupRouteImport.update({
    id: '/me/security/mfa-email-setup',
    path: '/me/security/mfa-email-setup',
    getParentRoute: () => AuthenticatedLayoutRoute,
  } as any)
const AuthenticatedLayoutMeSecurityChangePasswordRoute =
  AuthenticatedLayoutMeSecurityChangePasswordRouteImport.update({
    id: '/me/security/change-password',
    path: '/me/security/change-password',
    getParentRoute: () => AuthenticatedLayoutRoute,
  } as any)
const AuthenticatedLayoutPlatformTenantsTenantIdIndexRoute =
  AuthenticatedLayoutPlatformTenantsTenantIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedLayoutPlatformTenantsTenantIdRoute,
  } as any)
const AuthenticatedLayoutPlatformTenantsTenantIdUsersRoute =
  AuthenticatedLayoutPlatformTenantsTenantIdUsersRouteImport.update({
    id: '/users',
    path: '/users',
    getParentRoute: () => AuthenticatedLayoutPlatformTenantsTenantIdRoute,
  } as any)
const AuthenticatedLayoutPlatformTenantsTenantIdUserFieldsRoute =
  AuthenticatedLayoutPlatformTenantsTenantIdUserFieldsRouteImport.update({
    id: '/user-fields',
    path: '/user-fields',
    getParentRoute: () => AuthenticatedLayoutPlatformTenantsTenantIdRoute,
  } as any)
const AuthenticatedLayoutPlatformTenantsTenantIdRolesRoute =
  AuthenticatedLayoutPlatformTenantsTenantIdRolesRouteImport.update({
    id: '/roles',
    path: '/roles',
    getParentRoute: () => AuthenticatedLayoutPlatformTenantsTenantIdRoute,
  } as any)
const AuthenticatedLayoutPlatformTenantsTenantIdBrandingRoute =
  AuthenticatedLayoutPlatformTenantsTenantIdBrandingRouteImport.update({
    id: '/branding',
    path: '/branding',
    getParentRoute: () => AuthenticatedLayoutPlatformTenantsTenantIdRoute,
  } as any)
const AuthenticatedLayoutPlatformTenantsTenantIdLevelsLevelRoute =
  AuthenticatedLayoutPlatformTenantsTenantIdLevelsLevelRouteImport.update({
    id: '/levels/$level',
    path: '/levels/$level',
    getParentRoute: () => AuthenticatedLayoutPlatformTenantsTenantIdRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof AuthenticatedLayoutIndexRoute
  '/activate': typeof ActivateRoute
  '/forgot-password': typeof ForgotPasswordRoute
  '/login': typeof LoginRouteWithChildren
  '/no-access': typeof NoAccessRoute
  '/select-role': typeof SelectRoleRoute
  '/self-register': typeof SelfRegisterRoute
  '/wizard': typeof WizardRouteWithChildren
  '/collections': typeof BackofficeCollectionsRouteWithChildren
  '/credit': typeof BackofficeCreditRouteWithChildren
  '/retail-admin': typeof BackofficeRetailAdminRouteWithChildren
  '/sales': typeof BackofficeSalesRouteWithChildren
  '/superadmin': typeof BackofficeSuperadminRouteWithChildren
  '/dev/wizard-playground': typeof DevWizardPlaygroundRoute
  '/login/mfa-challenge': typeof LoginMfaChallengeRoute
  '/login/mfa-email-setup': typeof LoginMfaEmailSetupRoute
  '/login/mfa-setup': typeof LoginMfaSetupRoute
  '/login/mfa-totp-setup': typeof LoginMfaTotpSetupRoute
  '/login/new-password': typeof LoginNewPasswordRoute
  '/docs/': typeof DocsIndexRoute
  '/login/': typeof LoginIndexRoute
  '/wizard/': typeof WizardIndexRoute
  '/platform': typeof AuthenticatedLayoutPlatformRouteWithChildren
  '/collections/$section': typeof BackofficeCollectionsSectionRoute
  '/collections/agenda': typeof BackofficeCollectionsAgendaRoute
  '/collections/customers': typeof BackofficeCollectionsCustomersRoute
  '/collections/payments': typeof BackofficeCollectionsPaymentsRoute
  '/collections/promises': typeof BackofficeCollectionsPromisesRoute
  '/credit/$section': typeof BackofficeCreditSectionRoute
  '/credit/cohorts': typeof BackofficeCreditCohortsRoute
  '/credit/collections': typeof BackofficeCreditCollectionsRoute
  '/credit/customer-messages': typeof BackofficeCreditCustomerMessagesRoute
  '/credit/customers': typeof BackofficeCreditCustomersRoute
  '/credit/installments': typeof BackofficeCreditInstallmentsRoute
  '/credit/mdm': typeof BackofficeCreditMdmRoute
  '/credit/modelia': typeof BackofficeCreditModeliaRoute
  '/credit/origination': typeof BackofficeCreditOriginationRoute
  '/credit/policies': typeof BackofficeCreditPoliciesRoute
  '/credit/portfolio': typeof BackofficeCreditPortfolioRoute
  '/credit/promotions': typeof BackofficeCreditPromotionsRoute
  '/credit/reconciliation': typeof BackofficeCreditReconciliationRoute
  '/credit/reports': typeof BackofficeCreditReportsRoute
  '/credit/segments': typeof BackofficeCreditSegmentsRoute
  '/credit/transfers': typeof BackofficeCreditTransfersRoute
  '/retail-admin/$section': typeof BackofficeRetailAdminSectionRoute
  '/sales/$section': typeof BackofficeSalesSectionRoute
  '/superadmin/$section': typeof BackofficeSuperadminSectionRoute
  '/superadmin/global-config': typeof BackofficeSuperadminGlobalConfigRoute
  '/docs/$docId/$sectionId': typeof DocsDocIdSectionIdRoute
  '/wizard/s/$sessionId': typeof WizardSSessionIdRouteWithChildren
  '/collections/': typeof BackofficeCollectionsIndexRoute
  '/credit/': typeof BackofficeCreditIndexRoute
  '/retail-admin/': typeof BackofficeRetailAdminIndexRoute
  '/sales/': typeof BackofficeSalesIndexRoute
  '/superadmin/': typeof BackofficeSuperadminIndexRoute
  '/docs/$docId/': typeof DocsDocIdIndexRoute
  '/me/profile': typeof AuthenticatedLayoutMeProfileRoute
  '/platform/admins': typeof AuthenticatedLayoutPlatformAdminsRoute
  '/platform/audit': typeof AuthenticatedLayoutPlatformAuditRoute
  '/platform/branding': typeof AuthenticatedLayoutPlatformBrandingRoute
  '/platform/roles': typeof AuthenticatedLayoutPlatformRolesRoute
  '/platform/security': typeof AuthenticatedLayoutPlatformSecurityRoute
  '/platform/tenant-types': typeof AuthenticatedLayoutPlatformTenantTypesRoute
  '/seccion/$key': typeof AuthenticatedLayoutSeccionKeyRoute
  '/tenant/audit': typeof AuthenticatedLayoutTenantAuditRoute
  '/tenant/branding': typeof AuthenticatedLayoutTenantBrandingRoute
  '/tenant/groups': typeof AuthenticatedLayoutTenantGroupsRoute
  '/tenant/security': typeof AuthenticatedLayoutTenantSecurityRoute
  '/wizard/s/$sessionId/$step': typeof WizardSSessionIdStepRoute
  '/wizard/s/$sessionId/': typeof WizardSSessionIdIndexRoute
  '/me/security/change-password': typeof AuthenticatedLayoutMeSecurityChangePasswordRoute
  '/me/security/mfa-email-setup': typeof AuthenticatedLayoutMeSecurityMfaEmailSetupRoute
  '/me/security/mfa-preference': typeof AuthenticatedLayoutMeSecurityMfaPreferenceRoute
  '/me/security/mfa-setup': typeof AuthenticatedLayoutMeSecurityMfaSetupRoute
  '/me/security/mfa-sms-setup': typeof AuthenticatedLayoutMeSecurityMfaSmsSetupRoute
  '/me/security/mfa-totp-setup': typeof AuthenticatedLayoutMeSecurityMfaTotpSetupRoute
  '/platform/applications/$applicationId': typeof AuthenticatedLayoutPlatformApplicationsApplicationIdRoute
  '/platform/tenants/$tenantId': typeof AuthenticatedLayoutPlatformTenantsTenantIdRouteWithChildren
  '/tenant/roles/$roleId': typeof AuthenticatedLayoutTenantRolesRoleIdRoute
  '/tenant/users/new': typeof AuthenticatedLayoutTenantUsersNewRoute
  '/me/security/': typeof AuthenticatedLayoutMeSecurityIndexRoute
  '/platform/applications/': typeof AuthenticatedLayoutPlatformApplicationsIndexRoute
  '/platform/tenants/': typeof AuthenticatedLayoutPlatformTenantsIndexRoute
  '/tenant/roles/': typeof AuthenticatedLayoutTenantRolesIndexRoute
  '/tenant/users/': typeof AuthenticatedLayoutTenantUsersIndexRoute
  '/platform/tenants/$tenantId/branding': typeof AuthenticatedLayoutPlatformTenantsTenantIdBrandingRoute
  '/platform/tenants/$tenantId/roles': typeof AuthenticatedLayoutPlatformTenantsTenantIdRolesRoute
  '/platform/tenants/$tenantId/user-fields': typeof AuthenticatedLayoutPlatformTenantsTenantIdUserFieldsRoute
  '/platform/tenants/$tenantId/users': typeof AuthenticatedLayoutPlatformTenantsTenantIdUsersRoute
  '/platform/tenants/$tenantId/': typeof AuthenticatedLayoutPlatformTenantsTenantIdIndexRoute
  '/platform/tenants/$tenantId/levels/$level': typeof AuthenticatedLayoutPlatformTenantsTenantIdLevelsLevelRoute
}
export interface FileRoutesByTo {
  '/': typeof AuthenticatedLayoutIndexRoute
  '/activate': typeof ActivateRoute
  '/forgot-password': typeof ForgotPasswordRoute
  '/no-access': typeof NoAccessRoute
  '/select-role': typeof SelectRoleRoute
  '/self-register': typeof SelfRegisterRoute
  '/dev/wizard-playground': typeof DevWizardPlaygroundRoute
  '/login/mfa-challenge': typeof LoginMfaChallengeRoute
  '/login/mfa-email-setup': typeof LoginMfaEmailSetupRoute
  '/login/mfa-setup': typeof LoginMfaSetupRoute
  '/login/mfa-totp-setup': typeof LoginMfaTotpSetupRoute
  '/login/new-password': typeof LoginNewPasswordRoute
  '/docs': typeof DocsIndexRoute
  '/login': typeof LoginIndexRoute
  '/wizard': typeof WizardIndexRoute
  '/platform': typeof AuthenticatedLayoutPlatformRouteWithChildren
  '/collections/$section': typeof BackofficeCollectionsSectionRoute
  '/collections/agenda': typeof BackofficeCollectionsAgendaRoute
  '/collections/customers': typeof BackofficeCollectionsCustomersRoute
  '/collections/payments': typeof BackofficeCollectionsPaymentsRoute
  '/collections/promises': typeof BackofficeCollectionsPromisesRoute
  '/credit/$section': typeof BackofficeCreditSectionRoute
  '/credit/cohorts': typeof BackofficeCreditCohortsRoute
  '/credit/collections': typeof BackofficeCreditCollectionsRoute
  '/credit/customer-messages': typeof BackofficeCreditCustomerMessagesRoute
  '/credit/customers': typeof BackofficeCreditCustomersRoute
  '/credit/installments': typeof BackofficeCreditInstallmentsRoute
  '/credit/mdm': typeof BackofficeCreditMdmRoute
  '/credit/modelia': typeof BackofficeCreditModeliaRoute
  '/credit/origination': typeof BackofficeCreditOriginationRoute
  '/credit/policies': typeof BackofficeCreditPoliciesRoute
  '/credit/portfolio': typeof BackofficeCreditPortfolioRoute
  '/credit/promotions': typeof BackofficeCreditPromotionsRoute
  '/credit/reconciliation': typeof BackofficeCreditReconciliationRoute
  '/credit/reports': typeof BackofficeCreditReportsRoute
  '/credit/segments': typeof BackofficeCreditSegmentsRoute
  '/credit/transfers': typeof BackofficeCreditTransfersRoute
  '/retail-admin/$section': typeof BackofficeRetailAdminSectionRoute
  '/sales/$section': typeof BackofficeSalesSectionRoute
  '/superadmin/$section': typeof BackofficeSuperadminSectionRoute
  '/superadmin/global-config': typeof BackofficeSuperadminGlobalConfigRoute
  '/docs/$docId/$sectionId': typeof DocsDocIdSectionIdRoute
  '/collections': typeof BackofficeCollectionsIndexRoute
  '/credit': typeof BackofficeCreditIndexRoute
  '/retail-admin': typeof BackofficeRetailAdminIndexRoute
  '/sales': typeof BackofficeSalesIndexRoute
  '/superadmin': typeof BackofficeSuperadminIndexRoute
  '/docs/$docId': typeof DocsDocIdIndexRoute
  '/me/profile': typeof AuthenticatedLayoutMeProfileRoute
  '/platform/admins': typeof AuthenticatedLayoutPlatformAdminsRoute
  '/platform/audit': typeof AuthenticatedLayoutPlatformAuditRoute
  '/platform/branding': typeof AuthenticatedLayoutPlatformBrandingRoute
  '/platform/roles': typeof AuthenticatedLayoutPlatformRolesRoute
  '/platform/security': typeof AuthenticatedLayoutPlatformSecurityRoute
  '/platform/tenant-types': typeof AuthenticatedLayoutPlatformTenantTypesRoute
  '/seccion/$key': typeof AuthenticatedLayoutSeccionKeyRoute
  '/tenant/audit': typeof AuthenticatedLayoutTenantAuditRoute
  '/tenant/branding': typeof AuthenticatedLayoutTenantBrandingRoute
  '/tenant/groups': typeof AuthenticatedLayoutTenantGroupsRoute
  '/tenant/security': typeof AuthenticatedLayoutTenantSecurityRoute
  '/wizard/s/$sessionId/$step': typeof WizardSSessionIdStepRoute
  '/wizard/s/$sessionId': typeof WizardSSessionIdIndexRoute
  '/me/security/change-password': typeof AuthenticatedLayoutMeSecurityChangePasswordRoute
  '/me/security/mfa-email-setup': typeof AuthenticatedLayoutMeSecurityMfaEmailSetupRoute
  '/me/security/mfa-preference': typeof AuthenticatedLayoutMeSecurityMfaPreferenceRoute
  '/me/security/mfa-setup': typeof AuthenticatedLayoutMeSecurityMfaSetupRoute
  '/me/security/mfa-sms-setup': typeof AuthenticatedLayoutMeSecurityMfaSmsSetupRoute
  '/me/security/mfa-totp-setup': typeof AuthenticatedLayoutMeSecurityMfaTotpSetupRoute
  '/platform/applications/$applicationId': typeof AuthenticatedLayoutPlatformApplicationsApplicationIdRoute
  '/tenant/roles/$roleId': typeof AuthenticatedLayoutTenantRolesRoleIdRoute
  '/tenant/users/new': typeof AuthenticatedLayoutTenantUsersNewRoute
  '/me/security': typeof AuthenticatedLayoutMeSecurityIndexRoute
  '/platform/applications': typeof AuthenticatedLayoutPlatformApplicationsIndexRoute
  '/platform/tenants': typeof AuthenticatedLayoutPlatformTenantsIndexRoute
  '/tenant/roles': typeof AuthenticatedLayoutTenantRolesIndexRoute
  '/tenant/users': typeof AuthenticatedLayoutTenantUsersIndexRoute
  '/platform/tenants/$tenantId/branding': typeof AuthenticatedLayoutPlatformTenantsTenantIdBrandingRoute
  '/platform/tenants/$tenantId/roles': typeof AuthenticatedLayoutPlatformTenantsTenantIdRolesRoute
  '/platform/tenants/$tenantId/user-fields': typeof AuthenticatedLayoutPlatformTenantsTenantIdUserFieldsRoute
  '/platform/tenants/$tenantId/users': typeof AuthenticatedLayoutPlatformTenantsTenantIdUsersRoute
  '/platform/tenants/$tenantId': typeof AuthenticatedLayoutPlatformTenantsTenantIdIndexRoute
  '/platform/tenants/$tenantId/levels/$level': typeof AuthenticatedLayoutPlatformTenantsTenantIdLevelsLevelRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_backoffice': typeof BackofficeRouteWithChildren
  '/activate': typeof ActivateRoute
  '/forgot-password': typeof ForgotPasswordRoute
  '/login': typeof LoginRouteWithChildren
  '/no-access': typeof NoAccessRoute
  '/select-role': typeof SelectRoleRoute
  '/self-register': typeof SelfRegisterRoute
  '/wizard': typeof WizardRouteWithChildren
  '/_authenticated/_layout': typeof AuthenticatedLayoutRouteWithChildren
  '/_backoffice/collections': typeof BackofficeCollectionsRouteWithChildren
  '/_backoffice/credit': typeof BackofficeCreditRouteWithChildren
  '/_backoffice/retail-admin': typeof BackofficeRetailAdminRouteWithChildren
  '/_backoffice/sales': typeof BackofficeSalesRouteWithChildren
  '/_backoffice/superadmin': typeof BackofficeSuperadminRouteWithChildren
  '/dev/wizard-playground': typeof DevWizardPlaygroundRoute
  '/login/mfa-challenge': typeof LoginMfaChallengeRoute
  '/login/mfa-email-setup': typeof LoginMfaEmailSetupRoute
  '/login/mfa-setup': typeof LoginMfaSetupRoute
  '/login/mfa-totp-setup': typeof LoginMfaTotpSetupRoute
  '/login/new-password': typeof LoginNewPasswordRoute
  '/docs/': typeof DocsIndexRoute
  '/login/': typeof LoginIndexRoute
  '/wizard/': typeof WizardIndexRoute
  '/_authenticated/_layout/platform': typeof AuthenticatedLayoutPlatformRouteWithChildren
  '/_backoffice/collections/$section': typeof BackofficeCollectionsSectionRoute
  '/_backoffice/collections/agenda': typeof BackofficeCollectionsAgendaRoute
  '/_backoffice/collections/customers': typeof BackofficeCollectionsCustomersRoute
  '/_backoffice/collections/payments': typeof BackofficeCollectionsPaymentsRoute
  '/_backoffice/collections/promises': typeof BackofficeCollectionsPromisesRoute
  '/_backoffice/credit/$section': typeof BackofficeCreditSectionRoute
  '/_backoffice/credit/cohorts': typeof BackofficeCreditCohortsRoute
  '/_backoffice/credit/collections': typeof BackofficeCreditCollectionsRoute
  '/_backoffice/credit/customer-messages': typeof BackofficeCreditCustomerMessagesRoute
  '/_backoffice/credit/customers': typeof BackofficeCreditCustomersRoute
  '/_backoffice/credit/installments': typeof BackofficeCreditInstallmentsRoute
  '/_backoffice/credit/mdm': typeof BackofficeCreditMdmRoute
  '/_backoffice/credit/modelia': typeof BackofficeCreditModeliaRoute
  '/_backoffice/credit/origination': typeof BackofficeCreditOriginationRoute
  '/_backoffice/credit/policies': typeof BackofficeCreditPoliciesRoute
  '/_backoffice/credit/portfolio': typeof BackofficeCreditPortfolioRoute
  '/_backoffice/credit/promotions': typeof BackofficeCreditPromotionsRoute
  '/_backoffice/credit/reconciliation': typeof BackofficeCreditReconciliationRoute
  '/_backoffice/credit/reports': typeof BackofficeCreditReportsRoute
  '/_backoffice/credit/segments': typeof BackofficeCreditSegmentsRoute
  '/_backoffice/credit/transfers': typeof BackofficeCreditTransfersRoute
  '/_backoffice/retail-admin/$section': typeof BackofficeRetailAdminSectionRoute
  '/_backoffice/sales/$section': typeof BackofficeSalesSectionRoute
  '/_backoffice/superadmin/$section': typeof BackofficeSuperadminSectionRoute
  '/_backoffice/superadmin/global-config': typeof BackofficeSuperadminGlobalConfigRoute
  '/docs/$docId/$sectionId': typeof DocsDocIdSectionIdRoute
  '/wizard/s/$sessionId': typeof WizardSSessionIdRouteWithChildren
  '/_authenticated/_layout/': typeof AuthenticatedLayoutIndexRoute
  '/_backoffice/collections/': typeof BackofficeCollectionsIndexRoute
  '/_backoffice/credit/': typeof BackofficeCreditIndexRoute
  '/_backoffice/retail-admin/': typeof BackofficeRetailAdminIndexRoute
  '/_backoffice/sales/': typeof BackofficeSalesIndexRoute
  '/_backoffice/superadmin/': typeof BackofficeSuperadminIndexRoute
  '/docs/$docId/': typeof DocsDocIdIndexRoute
  '/_authenticated/_layout/me/profile': typeof AuthenticatedLayoutMeProfileRoute
  '/_authenticated/_layout/platform/admins': typeof AuthenticatedLayoutPlatformAdminsRoute
  '/_authenticated/_layout/platform/audit': typeof AuthenticatedLayoutPlatformAuditRoute
  '/_authenticated/_layout/platform/branding': typeof AuthenticatedLayoutPlatformBrandingRoute
  '/_authenticated/_layout/platform/roles': typeof AuthenticatedLayoutPlatformRolesRoute
  '/_authenticated/_layout/platform/security': typeof AuthenticatedLayoutPlatformSecurityRoute
  '/_authenticated/_layout/platform/tenant-types': typeof AuthenticatedLayoutPlatformTenantTypesRoute
  '/_authenticated/_layout/seccion/$key': typeof AuthenticatedLayoutSeccionKeyRoute
  '/_authenticated/_layout/tenant/audit': typeof AuthenticatedLayoutTenantAuditRoute
  '/_authenticated/_layout/tenant/branding': typeof AuthenticatedLayoutTenantBrandingRoute
  '/_authenticated/_layout/tenant/groups': typeof AuthenticatedLayoutTenantGroupsRoute
  '/_authenticated/_layout/tenant/security': typeof AuthenticatedLayoutTenantSecurityRoute
  '/wizard/s/$sessionId/$step': typeof WizardSSessionIdStepRoute
  '/wizard/s/$sessionId/': typeof WizardSSessionIdIndexRoute
  '/_authenticated/_layout/me/security/change-password': typeof AuthenticatedLayoutMeSecurityChangePasswordRoute
  '/_authenticated/_layout/me/security/mfa-email-setup': typeof AuthenticatedLayoutMeSecurityMfaEmailSetupRoute
  '/_authenticated/_layout/me/security/mfa-preference': typeof AuthenticatedLayoutMeSecurityMfaPreferenceRoute
  '/_authenticated/_layout/me/security/mfa-setup': typeof AuthenticatedLayoutMeSecurityMfaSetupRoute
  '/_authenticated/_layout/me/security/mfa-sms-setup': typeof AuthenticatedLayoutMeSecurityMfaSmsSetupRoute
  '/_authenticated/_layout/me/security/mfa-totp-setup': typeof AuthenticatedLayoutMeSecurityMfaTotpSetupRoute
  '/_authenticated/_layout/platform/applications/$applicationId': typeof AuthenticatedLayoutPlatformApplicationsApplicationIdRoute
  '/_authenticated/_layout/platform/tenants/$tenantId': typeof AuthenticatedLayoutPlatformTenantsTenantIdRouteWithChildren
  '/_authenticated/_layout/tenant/roles/$roleId': typeof AuthenticatedLayoutTenantRolesRoleIdRoute
  '/_authenticated/_layout/tenant/users/new': typeof AuthenticatedLayoutTenantUsersNewRoute
  '/_authenticated/_layout/me/security/': typeof AuthenticatedLayoutMeSecurityIndexRoute
  '/_authenticated/_layout/platform/applications/': typeof AuthenticatedLayoutPlatformApplicationsIndexRoute
  '/_authenticated/_layout/platform/tenants/': typeof AuthenticatedLayoutPlatformTenantsIndexRoute
  '/_authenticated/_layout/tenant/roles/': typeof AuthenticatedLayoutTenantRolesIndexRoute
  '/_authenticated/_layout/tenant/users/': typeof AuthenticatedLayoutTenantUsersIndexRoute
  '/_authenticated/_layout/platform/tenants/$tenantId/branding': typeof AuthenticatedLayoutPlatformTenantsTenantIdBrandingRoute
  '/_authenticated/_layout/platform/tenants/$tenantId/roles': typeof AuthenticatedLayoutPlatformTenantsTenantIdRolesRoute
  '/_authenticated/_layout/platform/tenants/$tenantId/user-fields': typeof AuthenticatedLayoutPlatformTenantsTenantIdUserFieldsRoute
  '/_authenticated/_layout/platform/tenants/$tenantId/users': typeof AuthenticatedLayoutPlatformTenantsTenantIdUsersRoute
  '/_authenticated/_layout/platform/tenants/$tenantId/': typeof AuthenticatedLayoutPlatformTenantsTenantIdIndexRoute
  '/_authenticated/_layout/platform/tenants/$tenantId/levels/$level': typeof AuthenticatedLayoutPlatformTenantsTenantIdLevelsLevelRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/activate'
    | '/forgot-password'
    | '/login'
    | '/no-access'
    | '/select-role'
    | '/self-register'
    | '/wizard'
    | '/collections'
    | '/credit'
    | '/retail-admin'
    | '/sales'
    | '/superadmin'
    | '/dev/wizard-playground'
    | '/login/mfa-challenge'
    | '/login/mfa-email-setup'
    | '/login/mfa-setup'
    | '/login/mfa-totp-setup'
    | '/login/new-password'
    | '/docs/'
    | '/login/'
    | '/wizard/'
    | '/platform'
    | '/collections/$section'
    | '/collections/agenda'
    | '/collections/customers'
    | '/collections/payments'
    | '/collections/promises'
    | '/credit/$section'
    | '/credit/cohorts'
    | '/credit/collections'
    | '/credit/customer-messages'
    | '/credit/customers'
    | '/credit/installments'
    | '/credit/mdm'
    | '/credit/modelia'
    | '/credit/origination'
    | '/credit/policies'
    | '/credit/portfolio'
    | '/credit/promotions'
    | '/credit/reconciliation'
    | '/credit/reports'
    | '/credit/segments'
    | '/credit/transfers'
    | '/retail-admin/$section'
    | '/sales/$section'
    | '/superadmin/$section'
    | '/superadmin/global-config'
    | '/docs/$docId/$sectionId'
    | '/wizard/s/$sessionId'
    | '/collections/'
    | '/credit/'
    | '/retail-admin/'
    | '/sales/'
    | '/superadmin/'
    | '/docs/$docId/'
    | '/me/profile'
    | '/platform/admins'
    | '/platform/audit'
    | '/platform/branding'
    | '/platform/roles'
    | '/platform/security'
    | '/platform/tenant-types'
    | '/seccion/$key'
    | '/tenant/audit'
    | '/tenant/branding'
    | '/tenant/groups'
    | '/tenant/security'
    | '/wizard/s/$sessionId/$step'
    | '/wizard/s/$sessionId/'
    | '/me/security/change-password'
    | '/me/security/mfa-email-setup'
    | '/me/security/mfa-preference'
    | '/me/security/mfa-setup'
    | '/me/security/mfa-sms-setup'
    | '/me/security/mfa-totp-setup'
    | '/platform/applications/$applicationId'
    | '/platform/tenants/$tenantId'
    | '/tenant/roles/$roleId'
    | '/tenant/users/new'
    | '/me/security/'
    | '/platform/applications/'
    | '/platform/tenants/'
    | '/tenant/roles/'
    | '/tenant/users/'
    | '/platform/tenants/$tenantId/branding'
    | '/platform/tenants/$tenantId/roles'
    | '/platform/tenants/$tenantId/user-fields'
    | '/platform/tenants/$tenantId/users'
    | '/platform/tenants/$tenantId/'
    | '/platform/tenants/$tenantId/levels/$level'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/activate'
    | '/forgot-password'
    | '/no-access'
    | '/select-role'
    | '/self-register'
    | '/dev/wizard-playground'
    | '/login/mfa-challenge'
    | '/login/mfa-email-setup'
    | '/login/mfa-setup'
    | '/login/mfa-totp-setup'
    | '/login/new-password'
    | '/docs'
    | '/login'
    | '/wizard'
    | '/platform'
    | '/collections/$section'
    | '/collections/agenda'
    | '/collections/customers'
    | '/collections/payments'
    | '/collections/promises'
    | '/credit/$section'
    | '/credit/cohorts'
    | '/credit/collections'
    | '/credit/customer-messages'
    | '/credit/customers'
    | '/credit/installments'
    | '/credit/mdm'
    | '/credit/modelia'
    | '/credit/origination'
    | '/credit/policies'
    | '/credit/portfolio'
    | '/credit/promotions'
    | '/credit/reconciliation'
    | '/credit/reports'
    | '/credit/segments'
    | '/credit/transfers'
    | '/retail-admin/$section'
    | '/sales/$section'
    | '/superadmin/$section'
    | '/superadmin/global-config'
    | '/docs/$docId/$sectionId'
    | '/collections'
    | '/credit'
    | '/retail-admin'
    | '/sales'
    | '/superadmin'
    | '/docs/$docId'
    | '/me/profile'
    | '/platform/admins'
    | '/platform/audit'
    | '/platform/branding'
    | '/platform/roles'
    | '/platform/security'
    | '/platform/tenant-types'
    | '/seccion/$key'
    | '/tenant/audit'
    | '/tenant/branding'
    | '/tenant/groups'
    | '/tenant/security'
    | '/wizard/s/$sessionId/$step'
    | '/wizard/s/$sessionId'
    | '/me/security/change-password'
    | '/me/security/mfa-email-setup'
    | '/me/security/mfa-preference'
    | '/me/security/mfa-setup'
    | '/me/security/mfa-sms-setup'
    | '/me/security/mfa-totp-setup'
    | '/platform/applications/$applicationId'
    | '/tenant/roles/$roleId'
    | '/tenant/users/new'
    | '/me/security'
    | '/platform/applications'
    | '/platform/tenants'
    | '/tenant/roles'
    | '/tenant/users'
    | '/platform/tenants/$tenantId/branding'
    | '/platform/tenants/$tenantId/roles'
    | '/platform/tenants/$tenantId/user-fields'
    | '/platform/tenants/$tenantId/users'
    | '/platform/tenants/$tenantId'
    | '/platform/tenants/$tenantId/levels/$level'
  id:
    | '__root__'
    | '/_backoffice'
    | '/activate'
    | '/forgot-password'
    | '/login'
    | '/no-access'
    | '/select-role'
    | '/self-register'
    | '/wizard'
    | '/_authenticated/_layout'
    | '/_backoffice/collections'
    | '/_backoffice/credit'
    | '/_backoffice/retail-admin'
    | '/_backoffice/sales'
    | '/_backoffice/superadmin'
    | '/dev/wizard-playground'
    | '/login/mfa-challenge'
    | '/login/mfa-email-setup'
    | '/login/mfa-setup'
    | '/login/mfa-totp-setup'
    | '/login/new-password'
    | '/docs/'
    | '/login/'
    | '/wizard/'
    | '/_authenticated/_layout/platform'
    | '/_backoffice/collections/$section'
    | '/_backoffice/collections/agenda'
    | '/_backoffice/collections/customers'
    | '/_backoffice/collections/payments'
    | '/_backoffice/collections/promises'
    | '/_backoffice/credit/$section'
    | '/_backoffice/credit/cohorts'
    | '/_backoffice/credit/collections'
    | '/_backoffice/credit/customer-messages'
    | '/_backoffice/credit/customers'
    | '/_backoffice/credit/installments'
    | '/_backoffice/credit/mdm'
    | '/_backoffice/credit/modelia'
    | '/_backoffice/credit/origination'
    | '/_backoffice/credit/policies'
    | '/_backoffice/credit/portfolio'
    | '/_backoffice/credit/promotions'
    | '/_backoffice/credit/reconciliation'
    | '/_backoffice/credit/reports'
    | '/_backoffice/credit/segments'
    | '/_backoffice/credit/transfers'
    | '/_backoffice/retail-admin/$section'
    | '/_backoffice/sales/$section'
    | '/_backoffice/superadmin/$section'
    | '/_backoffice/superadmin/global-config'
    | '/docs/$docId/$sectionId'
    | '/wizard/s/$sessionId'
    | '/_authenticated/_layout/'
    | '/_backoffice/collections/'
    | '/_backoffice/credit/'
    | '/_backoffice/retail-admin/'
    | '/_backoffice/sales/'
    | '/_backoffice/superadmin/'
    | '/docs/$docId/'
    | '/_authenticated/_layout/me/profile'
    | '/_authenticated/_layout/platform/admins'
    | '/_authenticated/_layout/platform/audit'
    | '/_authenticated/_layout/platform/branding'
    | '/_authenticated/_layout/platform/roles'
    | '/_authenticated/_layout/platform/security'
    | '/_authenticated/_layout/platform/tenant-types'
    | '/_authenticated/_layout/seccion/$key'
    | '/_authenticated/_layout/tenant/audit'
    | '/_authenticated/_layout/tenant/branding'
    | '/_authenticated/_layout/tenant/groups'
    | '/_authenticated/_layout/tenant/security'
    | '/wizard/s/$sessionId/$step'
    | '/wizard/s/$sessionId/'
    | '/_authenticated/_layout/me/security/change-password'
    | '/_authenticated/_layout/me/security/mfa-email-setup'
    | '/_authenticated/_layout/me/security/mfa-preference'
    | '/_authenticated/_layout/me/security/mfa-setup'
    | '/_authenticated/_layout/me/security/mfa-sms-setup'
    | '/_authenticated/_layout/me/security/mfa-totp-setup'
    | '/_authenticated/_layout/platform/applications/$applicationId'
    | '/_authenticated/_layout/platform/tenants/$tenantId'
    | '/_authenticated/_layout/tenant/roles/$roleId'
    | '/_authenticated/_layout/tenant/users/new'
    | '/_authenticated/_layout/me/security/'
    | '/_authenticated/_layout/platform/applications/'
    | '/_authenticated/_layout/platform/tenants/'
    | '/_authenticated/_layout/tenant/roles/'
    | '/_authenticated/_layout/tenant/users/'
    | '/_authenticated/_layout/platform/tenants/$tenantId/branding'
    | '/_authenticated/_layout/platform/tenants/$tenantId/roles'
    | '/_authenticated/_layout/platform/tenants/$tenantId/user-fields'
    | '/_authenticated/_layout/platform/tenants/$tenantId/users'
    | '/_authenticated/_layout/platform/tenants/$tenantId/'
    | '/_authenticated/_layout/platform/tenants/$tenantId/levels/$level'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  BackofficeRoute: typeof BackofficeRouteWithChildren
  ActivateRoute: typeof ActivateRoute
  ForgotPasswordRoute: typeof ForgotPasswordRoute
  LoginRoute: typeof LoginRouteWithChildren
  NoAccessRoute: typeof NoAccessRoute
  SelectRoleRoute: typeof SelectRoleRoute
  SelfRegisterRoute: typeof SelfRegisterRoute
  WizardRoute: typeof WizardRouteWithChildren
  AuthenticatedLayoutRoute: typeof AuthenticatedLayoutRouteWithChildren
  DevWizardPlaygroundRoute: typeof DevWizardPlaygroundRoute
  DocsIndexRoute: typeof DocsIndexRoute
  DocsDocIdSectionIdRoute: typeof DocsDocIdSectionIdRoute
  DocsDocIdIndexRoute: typeof DocsDocIdIndexRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/wizard': {
      id: '/wizard'
      path: '/wizard'
      fullPath: '/wizard'
      preLoaderRoute: typeof WizardRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/self-register': {
      id: '/self-register'
      path: '/self-register'
      fullPath: '/self-register'
      preLoaderRoute: typeof SelfRegisterRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/select-role': {
      id: '/select-role'
      path: '/select-role'
      fullPath: '/select-role'
      preLoaderRoute: typeof SelectRoleRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/no-access': {
      id: '/no-access'
      path: '/no-access'
      fullPath: '/no-access'
      preLoaderRoute: typeof NoAccessRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/forgot-password': {
      id: '/forgot-password'
      path: '/forgot-password'
      fullPath: '/forgot-password'
      preLoaderRoute: typeof ForgotPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/activate': {
      id: '/activate'
      path: '/activate'
      fullPath: '/activate'
      preLoaderRoute: typeof ActivateRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_backoffice': {
      id: '/_backoffice'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof BackofficeRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/wizard/': {
      id: '/wizard/'
      path: '/'
      fullPath: '/wizard/'
      preLoaderRoute: typeof WizardIndexRouteImport
      parentRoute: typeof WizardRoute
    }
    '/login/': {
      id: '/login/'
      path: '/'
      fullPath: '/login/'
      preLoaderRoute: typeof LoginIndexRouteImport
      parentRoute: typeof LoginRoute
    }
    '/docs/': {
      id: '/docs/'
      path: '/docs'
      fullPath: '/docs/'
      preLoaderRoute: typeof DocsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login/new-password': {
      id: '/login/new-password'
      path: '/new-password'
      fullPath: '/login/new-password'
      preLoaderRoute: typeof LoginNewPasswordRouteImport
      parentRoute: typeof LoginRoute
    }
    '/login/mfa-totp-setup': {
      id: '/login/mfa-totp-setup'
      path: '/mfa-totp-setup'
      fullPath: '/login/mfa-totp-setup'
      preLoaderRoute: typeof LoginMfaTotpSetupRouteImport
      parentRoute: typeof LoginRoute
    }
    '/login/mfa-setup': {
      id: '/login/mfa-setup'
      path: '/mfa-setup'
      fullPath: '/login/mfa-setup'
      preLoaderRoute: typeof LoginMfaSetupRouteImport
      parentRoute: typeof LoginRoute
    }
    '/login/mfa-email-setup': {
      id: '/login/mfa-email-setup'
      path: '/mfa-email-setup'
      fullPath: '/login/mfa-email-setup'
      preLoaderRoute: typeof LoginMfaEmailSetupRouteImport
      parentRoute: typeof LoginRoute
    }
    '/login/mfa-challenge': {
      id: '/login/mfa-challenge'
      path: '/mfa-challenge'
      fullPath: '/login/mfa-challenge'
      preLoaderRoute: typeof LoginMfaChallengeRouteImport
      parentRoute: typeof LoginRoute
    }
    '/dev/wizard-playground': {
      id: '/dev/wizard-playground'
      path: '/dev/wizard-playground'
      fullPath: '/dev/wizard-playground'
      preLoaderRoute: typeof DevWizardPlaygroundRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_backoffice/superadmin': {
      id: '/_backoffice/superadmin'
      path: '/superadmin'
      fullPath: '/superadmin'
      preLoaderRoute: typeof BackofficeSuperadminRouteImport
      parentRoute: typeof BackofficeRoute
    }
    '/_backoffice/sales': {
      id: '/_backoffice/sales'
      path: '/sales'
      fullPath: '/sales'
      preLoaderRoute: typeof BackofficeSalesRouteImport
      parentRoute: typeof BackofficeRoute
    }
    '/_backoffice/retail-admin': {
      id: '/_backoffice/retail-admin'
      path: '/retail-admin'
      fullPath: '/retail-admin'
      preLoaderRoute: typeof BackofficeRetailAdminRouteImport
      parentRoute: typeof BackofficeRoute
    }
    '/_backoffice/credit': {
      id: '/_backoffice/credit'
      path: '/credit'
      fullPath: '/credit'
      preLoaderRoute: typeof BackofficeCreditRouteImport
      parentRoute: typeof BackofficeRoute
    }
    '/_backoffice/collections': {
      id: '/_backoffice/collections'
      path: '/collections'
      fullPath: '/collections'
      preLoaderRoute: typeof BackofficeCollectionsRouteImport
      parentRoute: typeof BackofficeRoute
    }
    '/_authenticated/_layout': {
      id: '/_authenticated/_layout'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedLayoutRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/docs/$docId/': {
      id: '/docs/$docId/'
      path: '/docs/$docId'
      fullPath: '/docs/$docId/'
      preLoaderRoute: typeof DocsDocIdIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_backoffice/superadmin/': {
      id: '/_backoffice/superadmin/'
      path: '/'
      fullPath: '/superadmin/'
      preLoaderRoute: typeof BackofficeSuperadminIndexRouteImport
      parentRoute: typeof BackofficeSuperadminRoute
    }
    '/_backoffice/sales/': {
      id: '/_backoffice/sales/'
      path: '/'
      fullPath: '/sales/'
      preLoaderRoute: typeof BackofficeSalesIndexRouteImport
      parentRoute: typeof BackofficeSalesRoute
    }
    '/_backoffice/retail-admin/': {
      id: '/_backoffice/retail-admin/'
      path: '/'
      fullPath: '/retail-admin/'
      preLoaderRoute: typeof BackofficeRetailAdminIndexRouteImport
      parentRoute: typeof BackofficeRetailAdminRoute
    }
    '/_backoffice/credit/': {
      id: '/_backoffice/credit/'
      path: '/'
      fullPath: '/credit/'
      preLoaderRoute: typeof BackofficeCreditIndexRouteImport
      parentRoute: typeof BackofficeCreditRoute
    }
    '/_backoffice/collections/': {
      id: '/_backoffice/collections/'
      path: '/'
      fullPath: '/collections/'
      preLoaderRoute: typeof BackofficeCollectionsIndexRouteImport
      parentRoute: typeof BackofficeCollectionsRoute
    }
    '/_authenticated/_layout/': {
      id: '/_authenticated/_layout/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedLayoutIndexRouteImport
      parentRoute: typeof AuthenticatedLayoutRoute
    }
    '/wizard/s/$sessionId': {
      id: '/wizard/s/$sessionId'
      path: '/s/$sessionId'
      fullPath: '/wizard/s/$sessionId'
      preLoaderRoute: typeof WizardSSessionIdRouteImport
      parentRoute: typeof WizardRoute
    }
    '/docs/$docId/$sectionId': {
      id: '/docs/$docId/$sectionId'
      path: '/docs/$docId/$sectionId'
      fullPath: '/docs/$docId/$sectionId'
      preLoaderRoute: typeof DocsDocIdSectionIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_backoffice/superadmin/global-config': {
      id: '/_backoffice/superadmin/global-config'
      path: '/global-config'
      fullPath: '/superadmin/global-config'
      preLoaderRoute: typeof BackofficeSuperadminGlobalConfigRouteImport
      parentRoute: typeof BackofficeSuperadminRoute
    }
    '/_backoffice/superadmin/$section': {
      id: '/_backoffice/superadmin/$section'
      path: '/$section'
      fullPath: '/superadmin/$section'
      preLoaderRoute: typeof BackofficeSuperadminSectionRouteImport
      parentRoute: typeof BackofficeSuperadminRoute
    }
    '/_backoffice/sales/$section': {
      id: '/_backoffice/sales/$section'
      path: '/$section'
      fullPath: '/sales/$section'
      preLoaderRoute: typeof BackofficeSalesSectionRouteImport
      parentRoute: typeof BackofficeSalesRoute
    }
    '/_backoffice/retail-admin/$section': {
      id: '/_backoffice/retail-admin/$section'
      path: '/$section'
      fullPath: '/retail-admin/$section'
      preLoaderRoute: typeof BackofficeRetailAdminSectionRouteImport
      parentRoute: typeof BackofficeRetailAdminRoute
    }
    '/_backoffice/credit/transfers': {
      id: '/_backoffice/credit/transfers'
      path: '/transfers'
      fullPath: '/credit/transfers'
      preLoaderRoute: typeof BackofficeCreditTransfersRouteImport
      parentRoute: typeof BackofficeCreditRoute
    }
    '/_backoffice/credit/segments': {
      id: '/_backoffice/credit/segments'
      path: '/segments'
      fullPath: '/credit/segments'
      preLoaderRoute: typeof BackofficeCreditSegmentsRouteImport
      parentRoute: typeof BackofficeCreditRoute
    }
    '/_backoffice/credit/reports': {
      id: '/_backoffice/credit/reports'
      path: '/reports'
      fullPath: '/credit/reports'
      preLoaderRoute: typeof BackofficeCreditReportsRouteImport
      parentRoute: typeof BackofficeCreditRoute
    }
    '/_backoffice/credit/reconciliation': {
      id: '/_backoffice/credit/reconciliation'
      path: '/reconciliation'
      fullPath: '/credit/reconciliation'
      preLoaderRoute: typeof BackofficeCreditReconciliationRouteImport
      parentRoute: typeof BackofficeCreditRoute
    }
    '/_backoffice/credit/promotions': {
      id: '/_backoffice/credit/promotions'
      path: '/promotions'
      fullPath: '/credit/promotions'
      preLoaderRoute: typeof BackofficeCreditPromotionsRouteImport
      parentRoute: typeof BackofficeCreditRoute
    }
    '/_backoffice/credit/portfolio': {
      id: '/_backoffice/credit/portfolio'
      path: '/portfolio'
      fullPath: '/credit/portfolio'
      preLoaderRoute: typeof BackofficeCreditPortfolioRouteImport
      parentRoute: typeof BackofficeCreditRoute
    }
    '/_backoffice/credit/policies': {
      id: '/_backoffice/credit/policies'
      path: '/policies'
      fullPath: '/credit/policies'
      preLoaderRoute: typeof BackofficeCreditPoliciesRouteImport
      parentRoute: typeof BackofficeCreditRoute
    }
    '/_backoffice/credit/origination': {
      id: '/_backoffice/credit/origination'
      path: '/origination'
      fullPath: '/credit/origination'
      preLoaderRoute: typeof BackofficeCreditOriginationRouteImport
      parentRoute: typeof BackofficeCreditRoute
    }
    '/_backoffice/credit/modelia': {
      id: '/_backoffice/credit/modelia'
      path: '/modelia'
      fullPath: '/credit/modelia'
      preLoaderRoute: typeof BackofficeCreditModeliaRouteImport
      parentRoute: typeof BackofficeCreditRoute
    }
    '/_backoffice/credit/mdm': {
      id: '/_backoffice/credit/mdm'
      path: '/mdm'
      fullPath: '/credit/mdm'
      preLoaderRoute: typeof BackofficeCreditMdmRouteImport
      parentRoute: typeof BackofficeCreditRoute
    }
    '/_backoffice/credit/installments': {
      id: '/_backoffice/credit/installments'
      path: '/installments'
      fullPath: '/credit/installments'
      preLoaderRoute: typeof BackofficeCreditInstallmentsRouteImport
      parentRoute: typeof BackofficeCreditRoute
    }
    '/_backoffice/credit/customers': {
      id: '/_backoffice/credit/customers'
      path: '/customers'
      fullPath: '/credit/customers'
      preLoaderRoute: typeof BackofficeCreditCustomersRouteImport
      parentRoute: typeof BackofficeCreditRoute
    }
    '/_backoffice/credit/customer-messages': {
      id: '/_backoffice/credit/customer-messages'
      path: '/customer-messages'
      fullPath: '/credit/customer-messages'
      preLoaderRoute: typeof BackofficeCreditCustomerMessagesRouteImport
      parentRoute: typeof BackofficeCreditRoute
    }
    '/_backoffice/credit/collections': {
      id: '/_backoffice/credit/collections'
      path: '/collections'
      fullPath: '/credit/collections'
      preLoaderRoute: typeof BackofficeCreditCollectionsRouteImport
      parentRoute: typeof BackofficeCreditRoute
    }
    '/_backoffice/credit/cohorts': {
      id: '/_backoffice/credit/cohorts'
      path: '/cohorts'
      fullPath: '/credit/cohorts'
      preLoaderRoute: typeof BackofficeCreditCohortsRouteImport
      parentRoute: typeof BackofficeCreditRoute
    }
    '/_backoffice/credit/$section': {
      id: '/_backoffice/credit/$section'
      path: '/$section'
      fullPath: '/credit/$section'
      preLoaderRoute: typeof BackofficeCreditSectionRouteImport
      parentRoute: typeof BackofficeCreditRoute
    }
    '/_backoffice/collections/promises': {
      id: '/_backoffice/collections/promises'
      path: '/promises'
      fullPath: '/collections/promises'
      preLoaderRoute: typeof BackofficeCollectionsPromisesRouteImport
      parentRoute: typeof BackofficeCollectionsRoute
    }
    '/_backoffice/collections/payments': {
      id: '/_backoffice/collections/payments'
      path: '/payments'
      fullPath: '/collections/payments'
      preLoaderRoute: typeof BackofficeCollectionsPaymentsRouteImport
      parentRoute: typeof BackofficeCollectionsRoute
    }
    '/_backoffice/collections/customers': {
      id: '/_backoffice/collections/customers'
      path: '/customers'
      fullPath: '/collections/customers'
      preLoaderRoute: typeof BackofficeCollectionsCustomersRouteImport
      parentRoute: typeof BackofficeCollectionsRoute
    }
    '/_backoffice/collections/agenda': {
      id: '/_backoffice/collections/agenda'
      path: '/agenda'
      fullPath: '/collections/agenda'
      preLoaderRoute: typeof BackofficeCollectionsAgendaRouteImport
      parentRoute: typeof BackofficeCollectionsRoute
    }
    '/_backoffice/collections/$section': {
      id: '/_backoffice/collections/$section'
      path: '/$section'
      fullPath: '/collections/$section'
      preLoaderRoute: typeof BackofficeCollectionsSectionRouteImport
      parentRoute: typeof BackofficeCollectionsRoute
    }
    '/_authenticated/_layout/platform': {
      id: '/_authenticated/_layout/platform'
      path: '/platform'
      fullPath: '/platform'
      preLoaderRoute: typeof AuthenticatedLayoutPlatformRouteImport
      parentRoute: typeof AuthenticatedLayoutRoute
    }
    '/wizard/s/$sessionId/': {
      id: '/wizard/s/$sessionId/'
      path: '/'
      fullPath: '/wizard/s/$sessionId/'
      preLoaderRoute: typeof WizardSSessionIdIndexRouteImport
      parentRoute: typeof WizardSSessionIdRoute
    }
    '/wizard/s/$sessionId/$step': {
      id: '/wizard/s/$sessionId/$step'
      path: '/$step'
      fullPath: '/wizard/s/$sessionId/$step'
      preLoaderRoute: typeof WizardSSessionIdStepRouteImport
      parentRoute: typeof WizardSSessionIdRoute
    }
    '/_authenticated/_layout/tenant/security': {
      id: '/_authenticated/_layout/tenant/security'
      path: '/tenant/security'
      fullPath: '/tenant/security'
      preLoaderRoute: typeof AuthenticatedLayoutTenantSecurityRouteImport
      parentRoute: typeof AuthenticatedLayoutRoute
    }
    '/_authenticated/_layout/tenant/groups': {
      id: '/_authenticated/_layout/tenant/groups'
      path: '/tenant/groups'
      fullPath: '/tenant/groups'
      preLoaderRoute: typeof AuthenticatedLayoutTenantGroupsRouteImport
      parentRoute: typeof AuthenticatedLayoutRoute
    }
    '/_authenticated/_layout/tenant/branding': {
      id: '/_authenticated/_layout/tenant/branding'
      path: '/tenant/branding'
      fullPath: '/tenant/branding'
      preLoaderRoute: typeof AuthenticatedLayoutTenantBrandingRouteImport
      parentRoute: typeof AuthenticatedLayoutRoute
    }
    '/_authenticated/_layout/tenant/audit': {
      id: '/_authenticated/_layout/tenant/audit'
      path: '/tenant/audit'
      fullPath: '/tenant/audit'
      preLoaderRoute: typeof AuthenticatedLayoutTenantAuditRouteImport
      parentRoute: typeof AuthenticatedLayoutRoute
    }
    '/_authenticated/_layout/seccion/$key': {
      id: '/_authenticated/_layout/seccion/$key'
      path: '/seccion/$key'
      fullPath: '/seccion/$key'
      preLoaderRoute: typeof AuthenticatedLayoutSeccionKeyRouteImport
      parentRoute: typeof AuthenticatedLayoutRoute
    }
    '/_authenticated/_layout/platform/tenant-types': {
      id: '/_authenticated/_layout/platform/tenant-types'
      path: '/tenant-types'
      fullPath: '/platform/tenant-types'
      preLoaderRoute: typeof AuthenticatedLayoutPlatformTenantTypesRouteImport
      parentRoute: typeof AuthenticatedLayoutPlatformRoute
    }
    '/_authenticated/_layout/platform/security': {
      id: '/_authenticated/_layout/platform/security'
      path: '/security'
      fullPath: '/platform/security'
      preLoaderRoute: typeof AuthenticatedLayoutPlatformSecurityRouteImport
      parentRoute: typeof AuthenticatedLayoutPlatformRoute
    }
    '/_authenticated/_layout/platform/roles': {
      id: '/_authenticated/_layout/platform/roles'
      path: '/roles'
      fullPath: '/platform/roles'
      preLoaderRoute: typeof AuthenticatedLayoutPlatformRolesRouteImport
      parentRoute: typeof AuthenticatedLayoutPlatformRoute
    }
    '/_authenticated/_layout/platform/branding': {
      id: '/_authenticated/_layout/platform/branding'
      path: '/branding'
      fullPath: '/platform/branding'
      preLoaderRoute: typeof AuthenticatedLayoutPlatformBrandingRouteImport
      parentRoute: typeof AuthenticatedLayoutPlatformRoute
    }
    '/_authenticated/_layout/platform/audit': {
      id: '/_authenticated/_layout/platform/audit'
      path: '/audit'
      fullPath: '/platform/audit'
      preLoaderRoute: typeof AuthenticatedLayoutPlatformAuditRouteImport
      parentRoute: typeof AuthenticatedLayoutPlatformRoute
    }
    '/_authenticated/_layout/platform/admins': {
      id: '/_authenticated/_layout/platform/admins'
      path: '/admins'
      fullPath: '/platform/admins'
      preLoaderRoute: typeof AuthenticatedLayoutPlatformAdminsRouteImport
      parentRoute: typeof AuthenticatedLayoutPlatformRoute
    }
    '/_authenticated/_layout/me/profile': {
      id: '/_authenticated/_layout/me/profile'
      path: '/me/profile'
      fullPath: '/me/profile'
      preLoaderRoute: typeof AuthenticatedLayoutMeProfileRouteImport
      parentRoute: typeof AuthenticatedLayoutRoute
    }
    '/_authenticated/_layout/tenant/users/': {
      id: '/_authenticated/_layout/tenant/users/'
      path: '/tenant/users'
      fullPath: '/tenant/users/'
      preLoaderRoute: typeof AuthenticatedLayoutTenantUsersIndexRouteImport
      parentRoute: typeof AuthenticatedLayoutRoute
    }
    '/_authenticated/_layout/tenant/roles/': {
      id: '/_authenticated/_layout/tenant/roles/'
      path: '/tenant/roles'
      fullPath: '/tenant/roles/'
      preLoaderRoute: typeof AuthenticatedLayoutTenantRolesIndexRouteImport
      parentRoute: typeof AuthenticatedLayoutRoute
    }
    '/_authenticated/_layout/platform/tenants/': {
      id: '/_authenticated/_layout/platform/tenants/'
      path: '/tenants'
      fullPath: '/platform/tenants/'
      preLoaderRoute: typeof AuthenticatedLayoutPlatformTenantsIndexRouteImport
      parentRoute: typeof AuthenticatedLayoutPlatformRoute
    }
    '/_authenticated/_layout/platform/applications/': {
      id: '/_authenticated/_layout/platform/applications/'
      path: '/applications'
      fullPath: '/platform/applications/'
      preLoaderRoute: typeof AuthenticatedLayoutPlatformApplicationsIndexRouteImport
      parentRoute: typeof AuthenticatedLayoutPlatformRoute
    }
    '/_authenticated/_layout/me/security/': {
      id: '/_authenticated/_layout/me/security/'
      path: '/me/security'
      fullPath: '/me/security/'
      preLoaderRoute: typeof AuthenticatedLayoutMeSecurityIndexRouteImport
      parentRoute: typeof AuthenticatedLayoutRoute
    }
    '/_authenticated/_layout/tenant/users/new': {
      id: '/_authenticated/_layout/tenant/users/new'
      path: '/tenant/users/new'
      fullPath: '/tenant/users/new'
      preLoaderRoute: typeof AuthenticatedLayoutTenantUsersNewRouteImport
      parentRoute: typeof AuthenticatedLayoutRoute
    }
    '/_authenticated/_layout/tenant/roles/$roleId': {
      id: '/_authenticated/_layout/tenant/roles/$roleId'
      path: '/tenant/roles/$roleId'
      fullPath: '/tenant/roles/$roleId'
      preLoaderRoute: typeof AuthenticatedLayoutTenantRolesRoleIdRouteImport
      parentRoute: typeof AuthenticatedLayoutRoute
    }
    '/_authenticated/_layout/platform/tenants/$tenantId': {
      id: '/_authenticated/_layout/platform/tenants/$tenantId'
      path: '/tenants/$tenantId'
      fullPath: '/platform/tenants/$tenantId'
      preLoaderRoute: typeof AuthenticatedLayoutPlatformTenantsTenantIdRouteImport
      parentRoute: typeof AuthenticatedLayoutPlatformRoute
    }
    '/_authenticated/_layout/platform/applications/$applicationId': {
      id: '/_authenticated/_layout/platform/applications/$applicationId'
      path: '/applications/$applicationId'
      fullPath: '/platform/applications/$applicationId'
      preLoaderRoute: typeof AuthenticatedLayoutPlatformApplicationsApplicationIdRouteImport
      parentRoute: typeof AuthenticatedLayoutPlatformRoute
    }
    '/_authenticated/_layout/me/security/mfa-totp-setup': {
      id: '/_authenticated/_layout/me/security/mfa-totp-setup'
      path: '/me/security/mfa-totp-setup'
      fullPath: '/me/security/mfa-totp-setup'
      preLoaderRoute: typeof AuthenticatedLayoutMeSecurityMfaTotpSetupRouteImport
      parentRoute: typeof AuthenticatedLayoutRoute
    }
    '/_authenticated/_layout/me/security/mfa-sms-setup': {
      id: '/_authenticated/_layout/me/security/mfa-sms-setup'
      path: '/me/security/mfa-sms-setup'
      fullPath: '/me/security/mfa-sms-setup'
      preLoaderRoute: typeof AuthenticatedLayoutMeSecurityMfaSmsSetupRouteImport
      parentRoute: typeof AuthenticatedLayoutRoute
    }
    '/_authenticated/_layout/me/security/mfa-setup': {
      id: '/_authenticated/_layout/me/security/mfa-setup'
      path: '/me/security/mfa-setup'
      fullPath: '/me/security/mfa-setup'
      preLoaderRoute: typeof AuthenticatedLayoutMeSecurityMfaSetupRouteImport
      parentRoute: typeof AuthenticatedLayoutRoute
    }
    '/_authenticated/_layout/me/security/mfa-preference': {
      id: '/_authenticated/_layout/me/security/mfa-preference'
      path: '/me/security/mfa-preference'
      fullPath: '/me/security/mfa-preference'
      preLoaderRoute: typeof AuthenticatedLayoutMeSecurityMfaPreferenceRouteImport
      parentRoute: typeof AuthenticatedLayoutRoute
    }
    '/_authenticated/_layout/me/security/mfa-email-setup': {
      id: '/_authenticated/_layout/me/security/mfa-email-setup'
      path: '/me/security/mfa-email-setup'
      fullPath: '/me/security/mfa-email-setup'
      preLoaderRoute: typeof AuthenticatedLayoutMeSecurityMfaEmailSetupRouteImport
      parentRoute: typeof AuthenticatedLayoutRoute
    }
    '/_authenticated/_layout/me/security/change-password': {
      id: '/_authenticated/_layout/me/security/change-password'
      path: '/me/security/change-password'
      fullPath: '/me/security/change-password'
      preLoaderRoute: typeof AuthenticatedLayoutMeSecurityChangePasswordRouteImport
      parentRoute: typeof AuthenticatedLayoutRoute
    }
    '/_authenticated/_layout/platform/tenants/$tenantId/': {
      id: '/_authenticated/_layout/platform/tenants/$tenantId/'
      path: '/'
      fullPath: '/platform/tenants/$tenantId/'
      preLoaderRoute: typeof AuthenticatedLayoutPlatformTenantsTenantIdIndexRouteImport
      parentRoute: typeof AuthenticatedLayoutPlatformTenantsTenantIdRoute
    }
    '/_authenticated/_layout/platform/tenants/$tenantId/users': {
      id: '/_authenticated/_layout/platform/tenants/$tenantId/users'
      path: '/users'
      fullPath: '/platform/tenants/$tenantId/users'
      preLoaderRoute: typeof AuthenticatedLayoutPlatformTenantsTenantIdUsersRouteImport
      parentRoute: typeof AuthenticatedLayoutPlatformTenantsTenantIdRoute
    }
    '/_authenticated/_layout/platform/tenants/$tenantId/user-fields': {
      id: '/_authenticated/_layout/platform/tenants/$tenantId/user-fields'
      path: '/user-fields'
      fullPath: '/platform/tenants/$tenantId/user-fields'
      preLoaderRoute: typeof AuthenticatedLayoutPlatformTenantsTenantIdUserFieldsRouteImport
      parentRoute: typeof AuthenticatedLayoutPlatformTenantsTenantIdRoute
    }
    '/_authenticated/_layout/platform/tenants/$tenantId/roles': {
      id: '/_authenticated/_layout/platform/tenants/$tenantId/roles'
      path: '/roles'
      fullPath: '/platform/tenants/$tenantId/roles'
      preLoaderRoute: typeof AuthenticatedLayoutPlatformTenantsTenantIdRolesRouteImport
      parentRoute: typeof AuthenticatedLayoutPlatformTenantsTenantIdRoute
    }
    '/_authenticated/_layout/platform/tenants/$tenantId/branding': {
      id: '/_authenticated/_layout/platform/tenants/$tenantId/branding'
      path: '/branding'
      fullPath: '/platform/tenants/$tenantId/branding'
      preLoaderRoute: typeof AuthenticatedLayoutPlatformTenantsTenantIdBrandingRouteImport
      parentRoute: typeof AuthenticatedLayoutPlatformTenantsTenantIdRoute
    }
    '/_authenticated/_layout/platform/tenants/$tenantId/levels/$level': {
      id: '/_authenticated/_layout/platform/tenants/$tenantId/levels/$level'
      path: '/levels/$level'
      fullPath: '/platform/tenants/$tenantId/levels/$level'
      preLoaderRoute: typeof AuthenticatedLayoutPlatformTenantsTenantIdLevelsLevelRouteImport
      parentRoute: typeof AuthenticatedLayoutPlatformTenantsTenantIdRoute
    }
  }
}

interface BackofficeCollectionsRouteChildren {
  BackofficeCollectionsSectionRoute: typeof BackofficeCollectionsSectionRoute
  BackofficeCollectionsAgendaRoute: typeof BackofficeCollectionsAgendaRoute
  BackofficeCollectionsCustomersRoute: typeof BackofficeCollectionsCustomersRoute
  BackofficeCollectionsPaymentsRoute: typeof BackofficeCollectionsPaymentsRoute
  BackofficeCollectionsPromisesRoute: typeof BackofficeCollectionsPromisesRoute
  BackofficeCollectionsIndexRoute: typeof BackofficeCollectionsIndexRoute
}

const BackofficeCollectionsRouteChildren: BackofficeCollectionsRouteChildren = {
  BackofficeCollectionsSectionRoute: BackofficeCollectionsSectionRoute,
  BackofficeCollectionsAgendaRoute: BackofficeCollectionsAgendaRoute,
  BackofficeCollectionsCustomersRoute: BackofficeCollectionsCustomersRoute,
  BackofficeCollectionsPaymentsRoute: BackofficeCollectionsPaymentsRoute,
  BackofficeCollectionsPromisesRoute: BackofficeCollectionsPromisesRoute,
  BackofficeCollectionsIndexRoute: BackofficeCollectionsIndexRoute,
}

const BackofficeCollectionsRouteWithChildren =
  BackofficeCollectionsRoute._addFileChildren(
    BackofficeCollectionsRouteChildren,
  )

interface BackofficeCreditRouteChildren {
  BackofficeCreditSectionRoute: typeof BackofficeCreditSectionRoute
  BackofficeCreditCohortsRoute: typeof BackofficeCreditCohortsRoute
  BackofficeCreditCollectionsRoute: typeof BackofficeCreditCollectionsRoute
  BackofficeCreditCustomerMessagesRoute: typeof BackofficeCreditCustomerMessagesRoute
  BackofficeCreditCustomersRoute: typeof BackofficeCreditCustomersRoute
  BackofficeCreditInstallmentsRoute: typeof BackofficeCreditInstallmentsRoute
  BackofficeCreditMdmRoute: typeof BackofficeCreditMdmRoute
  BackofficeCreditModeliaRoute: typeof BackofficeCreditModeliaRoute
  BackofficeCreditOriginationRoute: typeof BackofficeCreditOriginationRoute
  BackofficeCreditPoliciesRoute: typeof BackofficeCreditPoliciesRoute
  BackofficeCreditPortfolioRoute: typeof BackofficeCreditPortfolioRoute
  BackofficeCreditPromotionsRoute: typeof BackofficeCreditPromotionsRoute
  BackofficeCreditReconciliationRoute: typeof BackofficeCreditReconciliationRoute
  BackofficeCreditReportsRoute: typeof BackofficeCreditReportsRoute
  BackofficeCreditSegmentsRoute: typeof BackofficeCreditSegmentsRoute
  BackofficeCreditTransfersRoute: typeof BackofficeCreditTransfersRoute
  BackofficeCreditIndexRoute: typeof BackofficeCreditIndexRoute
}

const BackofficeCreditRouteChildren: BackofficeCreditRouteChildren = {
  BackofficeCreditSectionRoute: BackofficeCreditSectionRoute,
  BackofficeCreditCohortsRoute: BackofficeCreditCohortsRoute,
  BackofficeCreditCollectionsRoute: BackofficeCreditCollectionsRoute,
  BackofficeCreditCustomerMessagesRoute: BackofficeCreditCustomerMessagesRoute,
  BackofficeCreditCustomersRoute: BackofficeCreditCustomersRoute,
  BackofficeCreditInstallmentsRoute: BackofficeCreditInstallmentsRoute,
  BackofficeCreditMdmRoute: BackofficeCreditMdmRoute,
  BackofficeCreditModeliaRoute: BackofficeCreditModeliaRoute,
  BackofficeCreditOriginationRoute: BackofficeCreditOriginationRoute,
  BackofficeCreditPoliciesRoute: BackofficeCreditPoliciesRoute,
  BackofficeCreditPortfolioRoute: BackofficeCreditPortfolioRoute,
  BackofficeCreditPromotionsRoute: BackofficeCreditPromotionsRoute,
  BackofficeCreditReconciliationRoute: BackofficeCreditReconciliationRoute,
  BackofficeCreditReportsRoute: BackofficeCreditReportsRoute,
  BackofficeCreditSegmentsRoute: BackofficeCreditSegmentsRoute,
  BackofficeCreditTransfersRoute: BackofficeCreditTransfersRoute,
  BackofficeCreditIndexRoute: BackofficeCreditIndexRoute,
}

const BackofficeCreditRouteWithChildren =
  BackofficeCreditRoute._addFileChildren(BackofficeCreditRouteChildren)

interface BackofficeRetailAdminRouteChildren {
  BackofficeRetailAdminSectionRoute: typeof BackofficeRetailAdminSectionRoute
  BackofficeRetailAdminIndexRoute: typeof BackofficeRetailAdminIndexRoute
}

const BackofficeRetailAdminRouteChildren: BackofficeRetailAdminRouteChildren = {
  BackofficeRetailAdminSectionRoute: BackofficeRetailAdminSectionRoute,
  BackofficeRetailAdminIndexRoute: BackofficeRetailAdminIndexRoute,
}

const BackofficeRetailAdminRouteWithChildren =
  BackofficeRetailAdminRoute._addFileChildren(
    BackofficeRetailAdminRouteChildren,
  )

interface BackofficeSalesRouteChildren {
  BackofficeSalesSectionRoute: typeof BackofficeSalesSectionRoute
  BackofficeSalesIndexRoute: typeof BackofficeSalesIndexRoute
}

const BackofficeSalesRouteChildren: BackofficeSalesRouteChildren = {
  BackofficeSalesSectionRoute: BackofficeSalesSectionRoute,
  BackofficeSalesIndexRoute: BackofficeSalesIndexRoute,
}

const BackofficeSalesRouteWithChildren = BackofficeSalesRoute._addFileChildren(
  BackofficeSalesRouteChildren,
)

interface BackofficeSuperadminRouteChildren {
  BackofficeSuperadminSectionRoute: typeof BackofficeSuperadminSectionRoute
  BackofficeSuperadminGlobalConfigRoute: typeof BackofficeSuperadminGlobalConfigRoute
  BackofficeSuperadminIndexRoute: typeof BackofficeSuperadminIndexRoute
}

const BackofficeSuperadminRouteChildren: BackofficeSuperadminRouteChildren = {
  BackofficeSuperadminSectionRoute: BackofficeSuperadminSectionRoute,
  BackofficeSuperadminGlobalConfigRoute: BackofficeSuperadminGlobalConfigRoute,
  BackofficeSuperadminIndexRoute: BackofficeSuperadminIndexRoute,
}

const BackofficeSuperadminRouteWithChildren =
  BackofficeSuperadminRoute._addFileChildren(BackofficeSuperadminRouteChildren)

interface BackofficeRouteChildren {
  BackofficeCollectionsRoute: typeof BackofficeCollectionsRouteWithChildren
  BackofficeCreditRoute: typeof BackofficeCreditRouteWithChildren
  BackofficeRetailAdminRoute: typeof BackofficeRetailAdminRouteWithChildren
  BackofficeSalesRoute: typeof BackofficeSalesRouteWithChildren
  BackofficeSuperadminRoute: typeof BackofficeSuperadminRouteWithChildren
}

const BackofficeRouteChildren: BackofficeRouteChildren = {
  BackofficeCollectionsRoute: BackofficeCollectionsRouteWithChildren,
  BackofficeCreditRoute: BackofficeCreditRouteWithChildren,
  BackofficeRetailAdminRoute: BackofficeRetailAdminRouteWithChildren,
  BackofficeSalesRoute: BackofficeSalesRouteWithChildren,
  BackofficeSuperadminRoute: BackofficeSuperadminRouteWithChildren,
}

const BackofficeRouteWithChildren = BackofficeRoute._addFileChildren(
  BackofficeRouteChildren,
)

interface LoginRouteChildren {
  LoginMfaChallengeRoute: typeof LoginMfaChallengeRoute
  LoginMfaEmailSetupRoute: typeof LoginMfaEmailSetupRoute
  LoginMfaSetupRoute: typeof LoginMfaSetupRoute
  LoginMfaTotpSetupRoute: typeof LoginMfaTotpSetupRoute
  LoginNewPasswordRoute: typeof LoginNewPasswordRoute
  LoginIndexRoute: typeof LoginIndexRoute
}

const LoginRouteChildren: LoginRouteChildren = {
  LoginMfaChallengeRoute: LoginMfaChallengeRoute,
  LoginMfaEmailSetupRoute: LoginMfaEmailSetupRoute,
  LoginMfaSetupRoute: LoginMfaSetupRoute,
  LoginMfaTotpSetupRoute: LoginMfaTotpSetupRoute,
  LoginNewPasswordRoute: LoginNewPasswordRoute,
  LoginIndexRoute: LoginIndexRoute,
}

const LoginRouteWithChildren = LoginRoute._addFileChildren(LoginRouteChildren)

interface WizardSSessionIdRouteChildren {
  WizardSSessionIdStepRoute: typeof WizardSSessionIdStepRoute
  WizardSSessionIdIndexRoute: typeof WizardSSessionIdIndexRoute
}

const WizardSSessionIdRouteChildren: WizardSSessionIdRouteChildren = {
  WizardSSessionIdStepRoute: WizardSSessionIdStepRoute,
  WizardSSessionIdIndexRoute: WizardSSessionIdIndexRoute,
}

const WizardSSessionIdRouteWithChildren =
  WizardSSessionIdRoute._addFileChildren(WizardSSessionIdRouteChildren)

interface WizardRouteChildren {
  WizardIndexRoute: typeof WizardIndexRoute
  WizardSSessionIdRoute: typeof WizardSSessionIdRouteWithChildren
}

const WizardRouteChildren: WizardRouteChildren = {
  WizardIndexRoute: WizardIndexRoute,
  WizardSSessionIdRoute: WizardSSessionIdRouteWithChildren,
}

const WizardRouteWithChildren =
  WizardRoute._addFileChildren(WizardRouteChildren)

interface AuthenticatedLayoutPlatformTenantsTenantIdRouteChildren {
  AuthenticatedLayoutPlatformTenantsTenantIdBrandingRoute: typeof AuthenticatedLayoutPlatformTenantsTenantIdBrandingRoute
  AuthenticatedLayoutPlatformTenantsTenantIdRolesRoute: typeof AuthenticatedLayoutPlatformTenantsTenantIdRolesRoute
  AuthenticatedLayoutPlatformTenantsTenantIdUserFieldsRoute: typeof AuthenticatedLayoutPlatformTenantsTenantIdUserFieldsRoute
  AuthenticatedLayoutPlatformTenantsTenantIdUsersRoute: typeof AuthenticatedLayoutPlatformTenantsTenantIdUsersRoute
  AuthenticatedLayoutPlatformTenantsTenantIdIndexRoute: typeof AuthenticatedLayoutPlatformTenantsTenantIdIndexRoute
  AuthenticatedLayoutPlatformTenantsTenantIdLevelsLevelRoute: typeof AuthenticatedLayoutPlatformTenantsTenantIdLevelsLevelRoute
}

const AuthenticatedLayoutPlatformTenantsTenantIdRouteChildren: AuthenticatedLayoutPlatformTenantsTenantIdRouteChildren =
  {
    AuthenticatedLayoutPlatformTenantsTenantIdBrandingRoute:
      AuthenticatedLayoutPlatformTenantsTenantIdBrandingRoute,
    AuthenticatedLayoutPlatformTenantsTenantIdRolesRoute:
      AuthenticatedLayoutPlatformTenantsTenantIdRolesRoute,
    AuthenticatedLayoutPlatformTenantsTenantIdUserFieldsRoute:
      AuthenticatedLayoutPlatformTenantsTenantIdUserFieldsRoute,
    AuthenticatedLayoutPlatformTenantsTenantIdUsersRoute:
      AuthenticatedLayoutPlatformTenantsTenantIdUsersRoute,
    AuthenticatedLayoutPlatformTenantsTenantIdIndexRoute:
      AuthenticatedLayoutPlatformTenantsTenantIdIndexRoute,
    AuthenticatedLayoutPlatformTenantsTenantIdLevelsLevelRoute:
      AuthenticatedLayoutPlatformTenantsTenantIdLevelsLevelRoute,
  }

const AuthenticatedLayoutPlatformTenantsTenantIdRouteWithChildren =
  AuthenticatedLayoutPlatformTenantsTenantIdRoute._addFileChildren(
    AuthenticatedLayoutPlatformTenantsTenantIdRouteChildren,
  )

interface AuthenticatedLayoutPlatformRouteChildren {
  AuthenticatedLayoutPlatformAdminsRoute: typeof AuthenticatedLayoutPlatformAdminsRoute
  AuthenticatedLayoutPlatformAuditRoute: typeof AuthenticatedLayoutPlatformAuditRoute
  AuthenticatedLayoutPlatformBrandingRoute: typeof AuthenticatedLayoutPlatformBrandingRoute
  AuthenticatedLayoutPlatformRolesRoute: typeof AuthenticatedLayoutPlatformRolesRoute
  AuthenticatedLayoutPlatformSecurityRoute: typeof AuthenticatedLayoutPlatformSecurityRoute
  AuthenticatedLayoutPlatformTenantTypesRoute: typeof AuthenticatedLayoutPlatformTenantTypesRoute
  AuthenticatedLayoutPlatformApplicationsApplicationIdRoute: typeof AuthenticatedLayoutPlatformApplicationsApplicationIdRoute
  AuthenticatedLayoutPlatformTenantsTenantIdRoute: typeof AuthenticatedLayoutPlatformTenantsTenantIdRouteWithChildren
  AuthenticatedLayoutPlatformApplicationsIndexRoute: typeof AuthenticatedLayoutPlatformApplicationsIndexRoute
  AuthenticatedLayoutPlatformTenantsIndexRoute: typeof AuthenticatedLayoutPlatformTenantsIndexRoute
}

const AuthenticatedLayoutPlatformRouteChildren: AuthenticatedLayoutPlatformRouteChildren =
  {
    AuthenticatedLayoutPlatformAdminsRoute:
      AuthenticatedLayoutPlatformAdminsRoute,
    AuthenticatedLayoutPlatformAuditRoute:
      AuthenticatedLayoutPlatformAuditRoute,
    AuthenticatedLayoutPlatformBrandingRoute:
      AuthenticatedLayoutPlatformBrandingRoute,
    AuthenticatedLayoutPlatformRolesRoute:
      AuthenticatedLayoutPlatformRolesRoute,
    AuthenticatedLayoutPlatformSecurityRoute:
      AuthenticatedLayoutPlatformSecurityRoute,
    AuthenticatedLayoutPlatformTenantTypesRoute:
      AuthenticatedLayoutPlatformTenantTypesRoute,
    AuthenticatedLayoutPlatformApplicationsApplicationIdRoute:
      AuthenticatedLayoutPlatformApplicationsApplicationIdRoute,
    AuthenticatedLayoutPlatformTenantsTenantIdRoute:
      AuthenticatedLayoutPlatformTenantsTenantIdRouteWithChildren,
    AuthenticatedLayoutPlatformApplicationsIndexRoute:
      AuthenticatedLayoutPlatformApplicationsIndexRoute,
    AuthenticatedLayoutPlatformTenantsIndexRoute:
      AuthenticatedLayoutPlatformTenantsIndexRoute,
  }

const AuthenticatedLayoutPlatformRouteWithChildren =
  AuthenticatedLayoutPlatformRoute._addFileChildren(
    AuthenticatedLayoutPlatformRouteChildren,
  )

interface AuthenticatedLayoutRouteChildren {
  AuthenticatedLayoutPlatformRoute: typeof AuthenticatedLayoutPlatformRouteWithChildren
  AuthenticatedLayoutIndexRoute: typeof AuthenticatedLayoutIndexRoute
  AuthenticatedLayoutMeProfileRoute: typeof AuthenticatedLayoutMeProfileRoute
  AuthenticatedLayoutSeccionKeyRoute: typeof AuthenticatedLayoutSeccionKeyRoute
  AuthenticatedLayoutTenantAuditRoute: typeof AuthenticatedLayoutTenantAuditRoute
  AuthenticatedLayoutTenantBrandingRoute: typeof AuthenticatedLayoutTenantBrandingRoute
  AuthenticatedLayoutTenantGroupsRoute: typeof AuthenticatedLayoutTenantGroupsRoute
  AuthenticatedLayoutTenantSecurityRoute: typeof AuthenticatedLayoutTenantSecurityRoute
  AuthenticatedLayoutMeSecurityChangePasswordRoute: typeof AuthenticatedLayoutMeSecurityChangePasswordRoute
  AuthenticatedLayoutMeSecurityMfaEmailSetupRoute: typeof AuthenticatedLayoutMeSecurityMfaEmailSetupRoute
  AuthenticatedLayoutMeSecurityMfaPreferenceRoute: typeof AuthenticatedLayoutMeSecurityMfaPreferenceRoute
  AuthenticatedLayoutMeSecurityMfaSetupRoute: typeof AuthenticatedLayoutMeSecurityMfaSetupRoute
  AuthenticatedLayoutMeSecurityMfaSmsSetupRoute: typeof AuthenticatedLayoutMeSecurityMfaSmsSetupRoute
  AuthenticatedLayoutMeSecurityMfaTotpSetupRoute: typeof AuthenticatedLayoutMeSecurityMfaTotpSetupRoute
  AuthenticatedLayoutTenantRolesRoleIdRoute: typeof AuthenticatedLayoutTenantRolesRoleIdRoute
  AuthenticatedLayoutTenantUsersNewRoute: typeof AuthenticatedLayoutTenantUsersNewRoute
  AuthenticatedLayoutMeSecurityIndexRoute: typeof AuthenticatedLayoutMeSecurityIndexRoute
  AuthenticatedLayoutTenantRolesIndexRoute: typeof AuthenticatedLayoutTenantRolesIndexRoute
  AuthenticatedLayoutTenantUsersIndexRoute: typeof AuthenticatedLayoutTenantUsersIndexRoute
}

const AuthenticatedLayoutRouteChildren: AuthenticatedLayoutRouteChildren = {
  AuthenticatedLayoutPlatformRoute:
    AuthenticatedLayoutPlatformRouteWithChildren,
  AuthenticatedLayoutIndexRoute: AuthenticatedLayoutIndexRoute,
  AuthenticatedLayoutMeProfileRoute: AuthenticatedLayoutMeProfileRoute,
  AuthenticatedLayoutSeccionKeyRoute: AuthenticatedLayoutSeccionKeyRoute,
  AuthenticatedLayoutTenantAuditRoute: AuthenticatedLayoutTenantAuditRoute,
  AuthenticatedLayoutTenantBrandingRoute:
    AuthenticatedLayoutTenantBrandingRoute,
  AuthenticatedLayoutTenantGroupsRoute: AuthenticatedLayoutTenantGroupsRoute,
  AuthenticatedLayoutTenantSecurityRoute:
    AuthenticatedLayoutTenantSecurityRoute,
  AuthenticatedLayoutMeSecurityChangePasswordRoute:
    AuthenticatedLayoutMeSecurityChangePasswordRoute,
  AuthenticatedLayoutMeSecurityMfaEmailSetupRoute:
    AuthenticatedLayoutMeSecurityMfaEmailSetupRoute,
  AuthenticatedLayoutMeSecurityMfaPreferenceRoute:
    AuthenticatedLayoutMeSecurityMfaPreferenceRoute,
  AuthenticatedLayoutMeSecurityMfaSetupRoute:
    AuthenticatedLayoutMeSecurityMfaSetupRoute,
  AuthenticatedLayoutMeSecurityMfaSmsSetupRoute:
    AuthenticatedLayoutMeSecurityMfaSmsSetupRoute,
  AuthenticatedLayoutMeSecurityMfaTotpSetupRoute:
    AuthenticatedLayoutMeSecurityMfaTotpSetupRoute,
  AuthenticatedLayoutTenantRolesRoleIdRoute:
    AuthenticatedLayoutTenantRolesRoleIdRoute,
  AuthenticatedLayoutTenantUsersNewRoute:
    AuthenticatedLayoutTenantUsersNewRoute,
  AuthenticatedLayoutMeSecurityIndexRoute:
    AuthenticatedLayoutMeSecurityIndexRoute,
  AuthenticatedLayoutTenantRolesIndexRoute:
    AuthenticatedLayoutTenantRolesIndexRoute,
  AuthenticatedLayoutTenantUsersIndexRoute:
    AuthenticatedLayoutTenantUsersIndexRoute,
}

const AuthenticatedLayoutRouteWithChildren =
  AuthenticatedLayoutRoute._addFileChildren(AuthenticatedLayoutRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  BackofficeRoute: BackofficeRouteWithChildren,
  ActivateRoute: ActivateRoute,
  ForgotPasswordRoute: ForgotPasswordRoute,
  LoginRoute: LoginRouteWithChildren,
  NoAccessRoute: NoAccessRoute,
  SelectRoleRoute: SelectRoleRoute,
  SelfRegisterRoute: SelfRegisterRoute,
  WizardRoute: WizardRouteWithChildren,
  AuthenticatedLayoutRoute: AuthenticatedLayoutRouteWithChildren,
  DevWizardPlaygroundRoute: DevWizardPlaygroundRoute,
  DocsIndexRoute: DocsIndexRoute,
  DocsDocIdSectionIdRoute: DocsDocIdSectionIdRoute,
  DocsDocIdIndexRoute: DocsDocIdIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
